import React from "react";
import QuickTalesIcon from "../assets/images/quick_tales_logo.png";
import LASHistoricParkIcon from "../assets/images/park_Logo.jpg";
import tableDummyImage from "../assets/images/tableImage.png";
import FilterIcon from "../assets/icons/filterIcon.png";
import TableHeadIcon from "../assets/icons/Boxicons.png";
import SortSelectedIcon from "../assets/icons/SortSelectedIcon.png";
import SortSelectedDescIcon from "../assets/icons/SortSelectedDescIcon.png";
import dropdownIcon from "../assets/icons/dropdownIcon.png";
import UploadIcon from "../assets/icons/uploadIcon.png";
import OrgLogo from "../assets/images/OrgLogo.png";
import QuicktaleLogo from "../assets/images/Q.png";
import audioSample from "../assets/audios/audioSample.mp3";
import UserProfileImage from "../GeneralAdmin/modules/GAUserProfile/components/UserProfileImage/UserProfileImage";

export const drawerWidth = 220;

export const images = {
  QuickTalesIcon,
  LASHistoricParkIcon,
  tableDummyImage,
  OrgLogo,
  QuicktaleLogo,
  UserProfileImage,
};

export const icons = {
  FilterIcon,
  TableHeadIcon,
  SortSelectedIcon,
  SortSelectedDescIcon,
  UploadIcon,
  dropdownIcon,
};

export const audios = {
  audioSample,
};

export const routes = {
  login: "/login",
  forgotPassword: "/forgot-password",
  home: "/home",
  dashboard: "/home",
  // dashboard: "/add-quick-tales-to-organization",
  addQuicktalesToOrg: "/add-quick-tales-to-organization",
  addQuicktalesToOrgDetails: "/add-quick-tales-to-organization/details/:quicktaleId",
  admins: "/admins",
  adminDetails: "/admins/details",
  addAdmin: "/admins/add",
  addContributor: "/contributors/add",
  albumsInOrg: "/albums-in-organization",
  albumInOrgDetails: "/albums-in-organization/details",
  // albumInOrgDetails: "/albums/details",
  addAlbum: "/albums-in-organization/add",
  addQuickTalesToAlbum: "/albums-in-organization/add-quicktales-to-album",
  areaManagement: "/area-management",
  addArea: "/area-management/add",
  areaDetails: "/area-management/details",
  addQTToArea: "/area-management/details/add-qt-to-area",
  addAlbumsToArea: "/area-management/details/add-albums-to-area",
  contributors: "/contributors",
  orgProfileManagement: "/organization-profile",
  notifications: "/notifications",
  help: "/help",
  quicktalesInOrg: "/quick-tales-in-organization",
  quicktaleInOrgDetails: "/quick-tales-in-organization/details/:quicktaleId",
  createQuickTale: "/quick-tales-in-organization/create",
  reactionsInOrg: "/reactions-in-organization",
  emailTemplates: "/email-templates",
  emailTemplateDetails: "/email-templates/details/:templateId",
  createEmailTemplate: "/email-templates/create",
  // QuickConnect (QuickCollect) guest-page templates.
  // See docs/QUICKCOLLECT_IMPLEMENTATION.md
  qcTemplateDetails: "/email-templates/quickconnect/details/:templateId",
  // Standard (General Admin) email templates that orgs can copy.
  standardEmailTemplates: "/email-templates/standard",
  standardEmailTemplateDetails: "/email-templates/standard/details/:templateId",
  batches: "/batches",
  batchDetails: "/batches/:batchId",
  batchQuicktaleDetails: "/batches/:batchId/quicktale/:batchQuicktaleId",
  reports: "/reports",
  logout: "/logout",
  inviteContributors: "/accept-contributor-invite/:ref/:status",
  inviteAdmin: "/accept-admin-invite/:ref/:status",
  userProfile: "/admin-user-profile",
  guestContributors: "/guest-contributors",
  organizationDashboard: "/organization-dashboard",
  // Public QuickCollect guest submission form.
  // See docs/QUICKCOLLECT_IMPLEMENTATION.md
  quickCollectSubmit: "/:orgHandle/:areaSlug/submit",
};
export const GeneralAdminRoutes = {
  generalAdmin: "/general-admin",
  dashboard: "/general-admin-dashboard",
  users: "/general-admin-users",
  userDetails: "/general-admin-users/details/:id",
  // userDetails: "/general-admin-users/details",
  quicktales: "/quicktales",
  quicktaleDetails: "/quicktales/details/:id",
  // quicktaleDetails: "/quicktales/details",
  reactions: "/reactions",
  reactionDetails: "/reactions/details",
  albums: "/albums",
  addGAAlbum: "/albums/add",
  albumDetails: "/albums/details",
  addQTsToGAAlbum: "/albums/details/add-quicktales-to-album",
  groups: "/groups",
  addGroup: "/groups/add",
  groupDetails: "/groups/details",
  addMembersToGroup: "/groups/details/add-members",
  addQuickTalesToGroup: "/groups/details/add-quicktales",
  organizations: "/organizations",
  addOrganization: "/organizations/add",
  organizationDetails: "/organizations/details/:id",
  // organizationDetails: "/organizations/details",
  contentModeration: "/content-moderation",
  contentModerationDetails: "/content-moderation/details/:id",
  // contentModerationDetails: "/content-moderation/details",
  adminUsers: "/admin-users",
  addAdminUser: "/admin-users/add",
  adminUserDetails: "/admin-users/details",
  reports: "/general-admin-reports",
  thirdPartyTools: "/third-party-tools",
  listenFeedSettings: "/listen-feed-settings",
  appVersionSettings: "/app-version-settings",
  qcDefaultTemplate: "/quickcollect-template",
  genEmailTemplates: "/standard-email-templates",
  genEmailTemplateDetails: "/standard-email-templates/details/:templateId",
  createGenEmailTemplate: "/standard-email-templates/create",
  salesPagesList: "/sales-pages",
  salesUploads: "/sales-uploads",
  salesContactSubmissions: "/sales-contact-submissions",
  salesPageAdd: "/sales-pages/page/add",
  salesPageEdit: "/sales-pages/page/edit/:id",
  salesPageContent: "/sales-pages/content/:pageId",
  salesPageSectionAdd: "/sales-pages/content/:pageId/add",
  salesPageSectionEdit: "/sales-pages/content/:pageId/edit/:id",
  classroomAudioReactions: "/classroom-audio-reactions",
  classroomAudioReactionDetails: "/classroom-audio-reactions/details/:id",
  logout: "/general-admin-logout",
  userProfile: "/general-admin-user-profile",
};

export const orgAdminSidebarSections = [
  {
    title: "Create",
    collapsible: true,
    children: [
      { title: "QuickTale", path: routes.createQuickTale },
      { title: "Import QuickTales", path: routes.batches, openImportModal: true },
      { title: "Email Template", path: routes.createEmailTemplate },
      { title: "Area", path: routes.addArea },
      { title: "Album", path: routes.addAlbum },
    ],
  },
  {
    title: "Review",
    collapsible: true,
    children: [
      { title: "Submitted QuickTales", path: routes.addQuicktalesToOrg },
      { title: "Audio Reactions", path: routes.reactionsInOrg },
      { title: "Contributors", path: routes.contributors },
    ],
  },
  {
    title: "Manage",
    collapsible: true,
    children: [
      { title: "QuickTales in Organization", path: routes.quicktalesInOrg },
      { title: "QuickTale Imports", path: routes.batches },
      { title: "Email Templates", path: routes.emailTemplates },
      { title: "Areas", path: routes.areaManagement },
      { title: "Albums", path: routes.albumsInOrg },
    ],
  },
  {
    title: "Notifications",
    collapsible: false,
    path: routes.notifications,
  },
  {
    title: "Organization",
    collapsible: true,
    children: [
      { title: "Admin Users", path: routes.admins },
      { title: "Organization Profile", path: routes.orgProfileManagement },
    ],
  },
  {
    title: "Help",
    collapsible: false,
    path: routes.help,
  },
  {
    title: "Logout",
    collapsible: false,
    path: routes.logout,
  },
];

export const sideDrawerListItems = [
  {
    title: "Submitted QuickTales",
    id: 5,
    selected: false,
    path: routes.addQuicktalesToOrg,
  },
  {
    title: "QuickTales in Organization",
    id: 2,
    selected: false,
    path: routes.quicktalesInOrg,
  },
  {
    title: "Batched QuickTales",
    id: 15,
    selected: false,
    path: routes.batches,
  },
  {
    title: "Area Management",
    id: 9,
    selected: false,
    path: routes.areaManagement,
  },
  {
    title: "Audio Reactions",
    id: 3,
    selected: false,
    path: routes.reactionsInOrg,
  },
  {
    title: "Contributors",
    id: 7,
    selected: false,
    path: routes.contributors,
  },
  {
    title: "Albums in Organization",
    id: 4,
    selected: false,
    path: routes.albumsInOrg,
  },
  {
    title: "Admin Users",
    id: 6,
    selected: false,
    path: routes.admins,
  },
  {
    title: "Email Templates",
    id: 14,
    selected: false,
    path: routes.emailTemplates,
  },
  {
    title: "Organization Profile",
    id: 10,
    selected: false,
    path: routes.orgProfileManagement,
  },
  {
    title: "Notifications",
    id: 11,
    selected: false,
    path: routes.notifications,
  },
  {
    title: "Help",
    id: 12,
    selected: false,
    path: routes.help,
  },
  // {
  //   title: "Analytics",
  //   id: 8,
  //   selected: false,
  //   path: routes.reports,
  // },
  {
    title: "Logout",
    id: 13,
    selected: false,
    path: routes.logout,
  },
];
export const GeneralAdminSideDrawerListItems = [
  {
    title: "Dashboard",
    id: 1,
    selected: true,
    path: GeneralAdminRoutes.dashboard,
  },
  {
    title: "Users",
    id: 2,
    selected: false,
    path: GeneralAdminRoutes.users,
  },
  {
    title: "Quicktales",
    id: 3,
    selected: false,
    path: GeneralAdminRoutes.quicktales,
  },
  {
    title: "Reactions",
    id: 4,
    selected: false,
    path: GeneralAdminRoutes.reactions,
  },
  {
    title: "Albums",
    id: 5,
    selected: false,
    path: GeneralAdminRoutes.albums,
  },
  {
    title: "Groups",
    id: 5.5,
    selected: false,
    path: GeneralAdminRoutes.groups,
  },
  {
    title: "Organizations",
    id: 6,
    selected: false,
    path: GeneralAdminRoutes.organizations,
  },
  {
    title: "Content Moderation",
    id: 7,
    selected: false,
    path: GeneralAdminRoutes.contentModeration,
  },
  {
    title: "Admin Users",
    id: 8,
    selected: false,
    path: GeneralAdminRoutes.adminUsers,
  },
  {
    title: "Reports",
    id: 9,
    selected: false,
    path: GeneralAdminRoutes.reports,
  },
  {
    title: "Settings",
    id: 10,
    selected: false,
    collapsible: true,
    children: [
      {
        title: "Visual Search",
        path: GeneralAdminRoutes.thirdPartyTools,
      },
      {
        title: "Listen Feed & Search",
        path: GeneralAdminRoutes.listenFeedSettings,
      },
      {
        title: "App Version",
        path: GeneralAdminRoutes.appVersionSettings,
      },
      {
        title: "QuickCollect Template",
        path: GeneralAdminRoutes.qcDefaultTemplate,
      },
      {
        title: "Standard Email Templates",
        path: GeneralAdminRoutes.genEmailTemplates,
      },
    ],
  },
  {
    title: "QuickTales.com",
    id: 10.4,
    selected: false,
    collapsible: true,
    children: [
      {
        title: "Pages",
        path: GeneralAdminRoutes.salesPagesList,
      },
      {
        title: "Uploads",
        path: GeneralAdminRoutes.salesUploads,
      },
      {
        title: "Contact Submissions",
        path: GeneralAdminRoutes.salesContactSubmissions,
      },
    ],
  },
  {
    title: "Classroom Audio Reactions",
    id: 10.5,
    selected: false,
    path: GeneralAdminRoutes.classroomAudioReactions,
  },
  {
    title: "Logout",
    id: 11,
    selected: false,
    path: GeneralAdminRoutes.logout,
  },
  // {
  //   title: <UserProfileImage />,
  //   id: 12,
  //   selected: false,
  //   path: GeneralAdminRoutes.userProfile,
  //   profileImage: true,
  // },
];

// ---------------------------------------------------------------------------
// Sales Pages CMS (salesPages + salesPagesContent) — section type registry.
// Drives the dynamic admin forms in GeneralAdmin > QuickTales.com.
// Field `type` values:
//   "text" | "textarea" | "url" | "image" | "number" | "boolean" |
//   "select" | "richtext".
// See docs/SALES_PAGES_CMS.md for the full schema.
// ---------------------------------------------------------------------------
export const SALES_SECTION_ORDER_STEP = 10;

// Which viewports a section appears on (top-level `displayOn` field).
// Missing/unknown values are treated as "both". Mobile = viewport <= 900px.
// See docs/SALES_PAGES_CMS.md "Device-specific sections".
export const SALES_DISPLAY_ON_DEFAULT = "both";
export const SALES_DISPLAY_ON_OPTIONS = [
  { value: "both", label: "Both (default)" },
  { value: "desktop", label: "Desktop only" },
  { value: "mobile", label: "Mobile only" },
];
export const normalizeSalesDisplayOn = (value) =>
  SALES_DISPLAY_ON_OPTIONS.some((opt) => opt.value === value)
    ? value
    : SALES_DISPLAY_ON_DEFAULT;

// Infrastructure reserved words a page slug must not collide with.
// See docs/SALES_PAGES_CMS.md "Slug resolution & routing".
export const SALES_RESERVED_SLUGS = [
  "owners",
  "members",
  "super",
  "organizations",
  "organization",
  "quicktale",
  "album",
  "user",
  "my-groups",
  "activities",
  "quicktales",
  "privacy",
  "tos",
  "terms",
  "login",
  "signup",
];

// Convert a title into a URL-safe slug.
export function slugifySalesPage(value) {
  return String(value || "")
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/[\s_]+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "");
}

export const SALES_SECTION_REGISTRY = {
  hero: {
    label: "Hero",
    description: "Top hero: headline, body copy, and a side image.",
    fields: [
      { key: "title", label: "Headline", type: "text", required: true },
      {
        key: "bodyText",
        label: "Body Text",
        type: "textarea",
        required: true,
        helper: "Separate paragraphs with a blank line.",
      },
      { key: "imageUrl", label: "Image", type: "image", required: true, imageSize: "large" },
      { key: "imageAlt", label: "Image Alt Text", type: "text" },
    ],
    hasItems: false,
  },
  grid3: {
    label: "3-Column Grid",
    description:
      "Responsive 3-column card grid. Cards can optionally include an image.",
    fields: [{ key: "title", label: "Section Heading", type: "text" }],
    hasItems: true,
    itemFields: [
      { key: "title", label: "Card Title", type: "text", required: true },
      { key: "text", label: "Card Body", type: "textarea", required: true },
      { key: "imageUrl", label: "Card Image", type: "image", imageSize: "medium" },
      { key: "imageAlt", label: "Image Alt Text", type: "text" },
    ],
  },
  grid2: {
    label: "2-Column Grid",
    description:
      "Responsive 2-column card grid with an optional lead image above.",
    fields: [
      { key: "title", label: "Section Heading", type: "text" },
      { key: "imageUrl", label: "Lead Image", type: "image", imageSize: "medium" },
      { key: "imageAlt", label: "Image Alt Text", type: "text" },
    ],
    hasItems: true,
    itemFields: [
      { key: "title", label: "Card Title", type: "text", required: true },
      { key: "text", label: "Card Body", type: "textarea", required: true },
    ],
  },
  video: {
    label: "Video",
    description: "Responsive YouTube embed (16:9).",
    fields: [
      { key: "title", label: "Heading", type: "text" },
      {
        key: "videoUrl",
        label: "Video URL",
        type: "url",
        required: true,
        helper: "Full YouTube URL or a bare video ID.",
      },
    ],
    hasItems: false,
  },
  testimonials: {
    label: "Testimonials",
    description: "3-column testimonial cards with quote and attribution.",
    fields: [{ key: "title", label: "Section Heading", type: "text" }],
    hasItems: true,
    itemFields: [
      { key: "quote", label: "Quote", type: "textarea", required: true },
      {
        key: "attribution",
        label: "Attribution",
        type: "textarea",
        required: true,
        helper: 'e.g. "- Stef Butler, VP\\nValley Relics Museum".',
      },
      { key: "imageUrl", label: "Logo / Headshot", type: "image", imageSize: "small" },
      { key: "imageAlt", label: "Image Alt Text", type: "text" },
    ],
  },
  logoScroll: {
    label: "Logo Scroller",
    description: "Horizontally scrolling row of customer logos.",
    fields: [{ key: "title", label: "Heading", type: "text" }],
    hasItems: true,
    itemFields: [
      { key: "logoUrl", label: "Logo", type: "image", required: true, imageSize: "small" },
      { key: "alt", label: "Alt Text / Name", type: "text" },
      { key: "href", label: "Link (optional)", type: "url" },
    ],
  },
  associations: {
    label: "Associations",
    description: "Centered static row of association logos.",
    fields: [{ key: "title", label: "Section Heading", type: "text" }],
    hasItems: true,
    itemFields: [
      { key: "logoUrl", label: "Logo", type: "image", required: true, imageSize: "small" },
      { key: "alt", label: "Alt Text / Name", type: "text" },
      { key: "href", label: "Link (optional)", type: "url" },
    ],
  },
  ctaBanner: {
    label: "CTA Banner",
    description: "Lead text with a call-to-action button.",
    fields: [
      { key: "text", label: "Lead Text", type: "textarea", required: true },
      { key: "ctaLabel", label: "Button Label", type: "text", required: true },
      {
        key: "ctaHref",
        label: "Button Target",
        type: "url",
        required: true,
        helper: "Route (e.g. /contact) or full URL.",
      },
    ],
    hasItems: false,
  },
  image: {
    label: "Image",
    description:
      "Full-width centered image or animated GIF. Also used for decorative dividers.",
    fields: [
      { key: "imageUrl", label: "Image", type: "image", required: true, imageSize: "large" },
      {
        key: "imageAlt",
        label: "Image Alt Text",
        type: "text",
        helper: "Leave empty for purely decorative separators.",
      },
      {
        key: "loop",
        label: "Loop (animated sources)",
        type: "boolean",
        helper: "Semantic flag for animated sources; GIFs loop natively.",
      },
      {
        key: "maxWidth",
        label: "Max Width (px)",
        type: "number",
        helper: "Cap the image width, e.g. 300 for a small divider.",
      },
      { key: "caption", label: "Caption", type: "text" },
    ],
    hasItems: false,
  },
  imageGrid: {
    label: "Image Grid",
    description: "Responsive grid of images, each optionally linked.",
    fields: [
      { key: "title", label: "Section Heading", type: "text" },
      {
        key: "columns",
        label: "Columns",
        type: "select",
        default: 3,
        options: [
          { value: 2, label: "2" },
          { value: 3, label: "3" },
          { value: 4, label: "4" },
        ],
      },
      {
        key: "gap",
        label: "Gap (px)",
        type: "number",
        default: 28,
        helper: "Spacing between grid cells.",
      },
      {
        key: "align",
        label: "Vertical Alignment",
        type: "select",
        default: "top",
        options: [
          { value: "top", label: "Top" },
          { value: "center", label: "Center" },
        ],
      },
      {
        key: "maxWidth",
        label: "Max Width (px)",
        type: "number",
        helper: "Max width of the grid; the grid is centered when set.",
      },
    ],
    hasItems: true,
    itemFields: [
      { key: "imageUrl", label: "Image", type: "image", required: true, imageSize: "medium" },
      { key: "imageAlt", label: "Image Alt Text", type: "text" },
      { key: "href", label: "Link (optional)", type: "url" },
      {
        key: "mobileOrder",
        label: "Mobile Order",
        type: "number",
        helper:
          "Optional. Position on mobile (ascending). Leave empty to use the desktop order.",
      },
    ],
  },
  //lottie: {
  //  label: "Lottie Animation",
 //   description:
 //     "Centered, autoplaying Lottie animation loaded from a JSON file.",
 //   fields: [
 //     {
 //       key: "lottieUrl",
 //       label: "Lottie JSON File",
 //       type: "file",
 //       required: true,
 //       accept: ".json,application/json",
 //       noun: "JSON",
 //       helper: "Upload a Lottie .json file (must be CORS-readable).",
 //     },
 //     { key: "loop", label: "Loop", type: "boolean", default: true },
 //     { key: "autoplay", label: "Autoplay", type: "boolean", default: true },
 //     {
//        key: "speed",
//        label: "Speed",
//        type: "number",
//        default: 1,
//        helper: "Playback speed multiplier (1 = normal).",
//      },
//      { key: "maxWidth", label: "Max Width (px)", type: "number" },
//      { key: "ariaLabel", label: "Accessible Label", type: "text" },
//      { key: "caption", label: "Caption", type: "text" },
//    ],
//    hasItems: false,
//  },
  embedHtml: {
    label: "HTML",
    description:
      "Raw HTML rendered in an isolated iframe (supports <style>/<script>).",
    fields: [
      { key: "title", label: "Section Heading", type: "text" },
      {
        key: "html",
        label: "HTML",
        type: "code",
        required: true,
        helper:
          "Full HTML for the iframe. Fully trusted — only paste code you control.",
      },
      {
        key: "height",
        label: "Height (px)",
        type: "number",
        helper: "Fixed iframe height.",
      },
      { key: "maxWidth", label: "Max Width (px)", type: "number" },
      {
        key: "scrolling",
        label: "Allow Scrolling",
        type: "boolean",
      },
    ],
    hasItems: false,
  },
  twoColumn: {
    label: "Two Column",
    description:
      "A single row of two columns, each holding an image, rich text, or HTML.",
    fields: [
      { key: "title", label: "Section Heading", type: "text" },
      { key: "gap", label: "Gap (px)", type: "number", default: 40 },
      {
        key: "align",
        label: "Vertical Alignment",
        type: "select",
        default: "center",
        options: [
          { value: "center", label: "Center" },
          { value: "top", label: "Top" },
        ],
      },
      { key: "maxWidth", label: "Max Width (px)", type: "number" },
      {
        key: "left",
        label: "Left Column",
        type: "column",
        default: { type: "richText", weight: 1 },
      },
      {
        key: "right",
        label: "Right Column",
        type: "column",
        default: { type: "richText", weight: 1 },
      },
    ],
    hasItems: false,
  },
  contactForm: {
    label: "Contact Form",
    description:
      "A pre-coded contact form (fixed fields) with a reCAPTCHA challenge.",
    fields: [
      { key: "title", label: "Section Heading", type: "text" },
      { key: "maxWidth", label: "Max Width (px)", type: "number" },
      {
        key: "submitLabel",
        label: "Submit Button Label",
        type: "text",
        helper: 'Defaults to "SUBMIT" if left empty.',
      },
      {
        key: "successMessage",
        label: "Success Message",
        type: "textarea",
        helper: "Shown after a successful submission.",
      },
      {
        key: "formName",
        label: "Form Name",
        type: "text",
        helper:
          'Purpose tag stored with the submission (e.g. "contact", "demo"). Defaults to "contact".',
      },
    ],
    hasItems: false,
  },
  richText: {
    label: "Rich Text",
    description:
      "A block of rich text with an optional brand-colored heading.",
    fields: [
      {
        key: "title",
        label: "Heading",
        type: "text",
        helper: "Brand-colored heading. Leave empty for no heading.",
      },
      { key: "html", label: "Body", type: "richtext", required: true },
      {
        key: "align",
        label: "Alignment",
        type: "select",
        options: [
          { value: "left", label: "Left" },
          { value: "center", label: "Center" },
        ],
      },
      { key: "maxWidth", label: "Max Width (px)", type: "number" },
    ],
    hasItems: false,
  },
  spacer: {
    label: "Spacer",
    description: "Vertical empty space between sections.",
    fields: [
      {
        key: "height",
        label: "Height (px)",
        type: "number",
        required: true,
        helper: "Vertical space in pixels (desktop & default).",
      },
      {
        key: "mobileHeight",
        label: "Mobile Height (px)",
        type: "number",
        helper: "Overrides height on mobile (≤700px). 0 collapses it.",
      },
    ],
    hasItems: false,
  },
};

export const SALES_SECTION_TYPE_OPTIONS = Object.keys(
  SALES_SECTION_REGISTRY
).map((value) => ({ value, label: SALES_SECTION_REGISTRY[value].label }));

// Column type registry for the `twoColumn` section. Each column object stores a
// `type` plus common fields (weight, mobileOrder) and type-specific fields.
// Used by the ColumnEditor. See docs/SALES_PAGES_CMS.md (twoColumn).
export const SALES_COLUMN_TYPE_OPTIONS = [
  { value: "image", label: "Image" },
  { value: "richText", label: "Rich Text" },
  { value: "html", label: "HTML" },
  { value: "contactForm", label: "Contact Form" },
];

export const SALES_COLUMN_COMMON_FIELDS = [
  {
    key: "weight",
    label: "Weight",
    type: "number",
    default: 1,
    helper: "Relative width vs. the other column (e.g. 1 and 2 = 1/3 & 2/3).",
  },
  {
    key: "mobileOrder",
    label: "Mobile Order",
    type: "number",
    helper: "Optional. Position on mobile (ascending).",
  },
];

export const SALES_COLUMN_FIELDS_BY_TYPE = {
  image: [
    { key: "imageUrl", label: "Image", type: "image", required: true, imageSize: "medium" },
    { key: "imageAlt", label: "Image Alt Text", type: "text" },
    { key: "href", label: "Link (optional)", type: "url" },
  ],
  richText: [
    { key: "html", label: "Body", type: "richtext", required: true },
    {
      key: "align",
      label: "Alignment",
      type: "select",
      default: "left",
      options: [
        { value: "left", label: "Left" },
        { value: "center", label: "Center" },
      ],
    },
  ],
  html: [
    {
      key: "html",
      label: "HTML",
      type: "code",
      required: true,
      helper: "Full HTML for the iframe. Fully trusted — only paste code you control.",
    },
    { key: "height", label: "Height (px)", type: "number" },
    { key: "scrolling", label: "Allow Scrolling", type: "boolean" },
  ],
  contactForm: [
    {
      key: "submitLabel",
      label: "Submit Button Label",
      type: "text",
      helper: 'Defaults to "SUBMIT" if left empty.',
    },
    {
      key: "successMessage",
      label: "Success Message",
      type: "textarea",
      helper: "Shown after a successful submission.",
    },
    {
      key: "formName",
      label: "Form Name",
      type: "text",
      helper:
        'Purpose tag stored with the submission. Defaults to "contact".',
    },
  ],
};

export function truncateString(str, num) {
  if (str.length <= num) {
    return str;
  }
  return str.slice(0, num) + "...";
}

export function formatLength(seconds) {
  if (isNaN(seconds)) return "00:00";
  const pad = (num) => String(num).padStart(2, "0");
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${minutes}:${pad(remainingSeconds)}`;
}

export function capitalizeFirstLetter(string) {
  if (typeof string !== "string") return string;
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function capitalizeFirstLetterOfEveryWord(string) {
  if (typeof string !== "string") return string;
  
  return string
    .split(' ') // Split the sentence into words
    .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize the first letter of each word
    .join(' '); // Join the words back into a sentence
}

/**
 * Words that should NOT be capitalized in title case (unless they are the first word).
 * Includes articles, coordinating conjunctions, and short/common prepositions.
 */
const TITLE_CASE_SKIP_WORDS = new Set([
  // Articles
  "a", "an", "the",
  // Coordinating conjunctions
  "and", "but", "or", "nor", "for", "yet", "so",
  // Short prepositions
  "at", "by", "in", "of", "off", "on", "to", "up", "as", "per", "via", "vs",
  // Longer prepositions commonly lowercased in title case
  "about", "above", "across", "after", "against", "along", "among", "around",
  "before", "behind", "below", "beneath", "beside", "between", "beyond",
  "down", "during", "except", "from", "into", "like", "near", "onto", "out",
  "outside", "over", "past", "since", "than", "through", "throughout", "till",
  "toward", "under", "underneath", "until", "upon", "with", "within", "without",
]);

/**
 * Converts a string to title case, skipping articles, conjunctions, and prepositions
 * (unless they are the first word). Always capitalizes the first word.
 *
 * Example: "the park at los angeles" → "The Park at Los Angeles"
 *
 * @param {string} value - The input string
 * @returns {string} - The title-cased string
 */
export function toTitleCaseArea(value) {
  if (typeof value !== "string") return value || "";
  return value
    .split(" ")
    .map((word, index) => {
      if (!word) return word;
      const lower = word.toLowerCase();
      // Always capitalize the first word; skip-list words stay lowercase otherwise
      if (index === 0 || !TITLE_CASE_SKIP_WORDS.has(lower)) {
        return word.charAt(0).toUpperCase() + word.slice(1);
      }
      return lower;
    })
    .join(" ");
}

/**
 * Wraps an onChange handler to auto-capitalize the first letter of each word
 * as the user types — but only when the cursor is at the end of the input
 * (i.e. the user is typing forward, not editing existing text mid-word).
 * This allows the user to go back and manually change a capital to lowercase.
 *
 * Usage: onChange={autoCapitalizeWords(handleChange)}
 *
 * @param {function} onChange - The original onChange handler
 * @returns {function} - A wrapped onChange handler
 */
export function autoCapitalizeWords(onChange) {
  return (e) => {
    const { value, selectionStart } = e.target;

    // If the cursor is NOT at the end, the user is editing mid-text — don't interfere
    if (selectionStart !== value.length) {
      return onChange(e);
    }

    const lastChar = value[value.length - 1];
    const prevChar = value[value.length - 2];

    // Capitalize if this is the first character typed, or the previous character was a space
    if (lastChar && lastChar !== ' ' && (prevChar === ' ' || prevChar === undefined)) {
      const syntheticEvent = {
        ...e,
        target: {
          ...e.target,
          value: value.slice(0, -1) + lastChar.toUpperCase(),
        },
      };
      return onChange(syntheticEvent);
    }

    return onChange(e);
  };
}


export function truncateText(text, maxLength) {
  if (text.length > maxLength) {
    return text.substring(0, maxLength) + "...";
  }
  return text;
}

export const onDateChipClick = (
  index,
  item,
  handleOpenCalneder,
  handleCloseCalneder,
  setFilterOptions,
  options,
  setOptions
) => {
  if (item.label === "Enter a Range") {
    handleOpenCalneder();
    let temp = [...options];
    options.forEach((optionItem, newIndex) => {
      if (index !== newIndex) {
        temp[newIndex].selected = false;
      }
    });
    temp[index].selected = !item.selected;
    setOptions(temp);
  } else {
    let temp = [...options];
    if (options[index].selected === false) {
      let filterOptionsTemp = [];
      // let filterOptionsTemp = [...filterOptions];
      if (filterOptionsTemp.includes(item.label) === false)
        if (item.label === "All") {
        } else {
          filterOptionsTemp.push(item.label);
        }
      options.forEach((optionItem, newIndex) => {
        if (index !== newIndex) {
          temp[newIndex].selected = false;
        }
      });

      setFilterOptions(filterOptionsTemp);
    }
    temp[index].selected = !item.selected;
    setOptions(temp);
    handleCloseCalneder();
  }
};

export const dateRangeOptions = [
  { label: "All", selected: true },
  { label: "Today", selected: false },
  { label: "Past Week", selected: false },
  { label: "Last 30 Days", selected: false },
  { label: "Last 12 Months", selected: false },
  { label: "Enter a Range", selected: false },
];

export const mainLayoutStyles = {
  height: "96vh",
  paddingLeft: 10,
  paddingTop: 50,
  background: "#F5F5F5",
  fontFamily: "Avenir Book, sans-serif",
};

// Get the current date
const currentDate = new Date();

// Determine the first day of the current month
const firstDayOfMonth = new Date(
  currentDate.getFullYear(),
  currentDate.getMonth(),
  1
);

// Determine the last day of the current month
const lastDayOfMonth = new Date(
  currentDate.getFullYear(),
  currentDate.getMonth() + 1,
  0
);

// Format the first day (Month day, Year)
const firstDayFormatted = new Intl.DateTimeFormat("en-US", {
  month: "short",
  day: "numeric",
}).format(firstDayOfMonth);

// Format the last day (just the day to ensure the month and year are not repeated)
const lastDayFormatted = new Intl.DateTimeFormat("en-US", {
  day: "numeric",
}).format(lastDayOfMonth);

// Format the year separately since it's common for both
const yearFormatted = new Intl.DateTimeFormat("en-US", {
  year: "numeric",
}).format(firstDayOfMonth);

// Concatenate the formatted strings to achieve the desired output
const dateRange = `${firstDayFormatted} - ${lastDayFormatted} ${yearFormatted}`;

export function showNotification(message) {
  const notification = document.getElementById("notification");
  notification.textContent = message;
  notification.style.display = "flex";

  // Function to hide notification
  const hideNotification = () => {
    notification.style.display = "none";
    document.removeEventListener("click", hideNotification);
  };

  // Add click listener to document
  //document.addEventListener("click", hideNotification);

  // Hide the notification after 5 seconds
  setTimeout(() => {
    hideNotification();
  }, 5000);
}

export function showNotificationCenter(message) {
  const notification = document.getElementById("notification");
  notification.textContent = message;
  notification.style.display = "flex";
  notification.style.transform = "translateX(-50%)";

  // Function to hide notification
  const hideNotification = () => {
    notification.style.display = "none";
    document.removeEventListener("click", hideNotification);
  };

  // Add click listener to document
  document.addEventListener("click", hideNotification);

  // Hide the notification after 5 seconds
 // setTimeout(() => {
 //   hideNotification();
 // }, 5000);
}

//sort function
// export function descendingComparator(a, b, orderBy) {
//   let aValue = a;
//   let bValue = b;

//   // Split the orderBy string to handle nested properties and array lengths
//   const orderByIds = orderBy.split(".");
//   orderByIds.forEach((property) => {
//     aValue = aValue && property in aValue ? aValue[property] : {};
//     bValue = bValue && property in bValue ? bValue[property] : {};
//   });

//   // Check if we're comparing array lengths
//   if (Array.isArray(aValue) && Array.isArray(bValue)) {
//     aValue = aValue.length;
//     bValue = bValue.length;
//   }

//   // Rest of the comparison logic remains the same...
//   // Check if the value is a timestamp object for date comparison
//   if (
//     orderBy.endsWith("updatedAt") ||
//     orderBy.endsWith("createdAt") ||
//     orderBy.endsWith("lastLoginDate") ||
//     orderBy.endsWith("date") ||
//     orderBy.endsWith("addedToOrgDate") ||
//     orderBy.endsWith("invitationToOrgDate")
//   ) {
//     aValue = aValue.seconds || -Infinity;
//     bValue = bValue.seconds || -Infinity;
//   } else if (typeof aValue === "string" && typeof bValue === "string") {
//     // Use localeCompare for strings to handle case-insensitive sorting
//     return aValue.localeCompare(bValue, undefined, { sensitivity: "base" });
//   }

//   // Check for empty objects or null/undefined values
//   if (Object.keys(aValue).length === 0 && Object.keys(bValue).length > 0)
//     return 1;
//   if (Object.keys(aValue).length > 0 && Object.keys(bValue).length === 0)
//     return -1;
//   if (Object.keys(aValue).length === 0 && Object.keys(bValue).length === 0)
//     return 0;

//   // For numbers and booleans
//   if (aValue < bValue) {
//     return -1;
//   }
//   if (aValue > bValue) {
//     return 1;
//   }
//   return 0;
// }

export function descendingComparator(a, b, orderBy) {
  let aValue = a;
  let bValue = b;

  // Split the orderBy string to handle nested properties and array lengths
  const orderByIds = orderBy.split(".");
  orderByIds.forEach((property) => {
    aValue = aValue && property in aValue ? aValue[property] : undefined;
    bValue = bValue && property in bValue ? bValue[property] : undefined;
  });

  // Debugging the extracted values
  // console.log(`Comparing ${orderBy}`, { aValue, bValue });

  if (Array.isArray(aValue) && Array.isArray(bValue)) {
    aValue = aValue.length;
    bValue = bValue.length;
  }
  
  // Custom sorting for firstName and lastName with name concatenation
  if (orderBy === "firstName") {
    const aFullName = `${a.firstName || ""} ${a.lastName || ""}`.trim();
    const bFullName = `${b.firstName || ""} ${b.lastName || ""}`.trim();
    return aFullName.localeCompare(bFullName, undefined, {
      sensitivity: "base",
    });
  }

  if (orderBy === "narratorData.userName") {
    const aNarratorName = a.narratorData?.userName || a.narrator || "";
    const bNarratorName = b.narratorData?.userName || b.narrator || "";
    return aNarratorName.localeCompare(bNarratorName, undefined, {
      sensitivity: "base",
    });
  }

  if (orderBy === "lastName") {
    const aFullName = `${a.lastName || ''} ${a.firstName || ''}`.trim();
    const bFullName = `${b.lastName || ''} ${b.firstName || ''}`.trim();
    return aFullName.localeCompare(bFullName, undefined, { sensitivity: "base" });
  }
  
  // Custom sorting for reaction status with specific order: Pending, Approved, Denied, Removed
  if (orderBy === "status") {
    const statusOrder = { "pending": 3, "approved": 2, "denied": 1, "removed": 0 };
    const aStatusOrder = statusOrder[aValue?.toLowerCase()] ?? 999;
    const bStatusOrder = statusOrder[bValue?.toLowerCase()] ?? 999;
    
    if (aStatusOrder !== bStatusOrder) {
      return aStatusOrder - bStatusOrder;
    }
    
    // If status is the same, sort by createdAt as secondary sort (newest first)
    const aCreatedAt = a.createdAt ? a.createdAt.seconds || -Infinity : -Infinity;
    const bCreatedAt = b.createdAt ? b.createdAt.seconds || -Infinity : -Infinity;
    return aCreatedAt - bCreatedAt;
  }
  //console.log("orderBy:", orderBy, "aValue:", aValue, "bValue:", bValue);
  // Custom sorting for QT approval status with specific order: Pending, Denied, Removed, then by Status Change Date descending
  if (orderBy === "approvalStatus.status") {
    const statusOrder = { "pending": 3, "denied": 2, "removed": 1 };
    const aStatusOrder = statusOrder[aValue?.toLowerCase()] ?? 0;
    const bStatusOrder = statusOrder[bValue?.toLowerCase()] ?? 0;
    
    if (aStatusOrder !== bStatusOrder) {
      return aStatusOrder - bStatusOrder; // Reverse order for descending priority
    }
    
    // If status is the same, sort by approvalStatus.updatedAt as secondary sort (newest first)
    const aUpdatedAt = a.approvalStatus?.updatedAt ? a.approvalStatus.updatedAt.seconds || -Infinity : -Infinity;
    const bUpdatedAt = b.approvalStatus?.updatedAt ? b.approvalStatus.updatedAt.seconds || -Infinity : -Infinity;
    return aUpdatedAt - bUpdatedAt; // Descending order (newest first)
  }


  if (
    orderBy.match(
      /(updatedAt|createdAt|lastLoginDate|date|addedToOrgDate|invitationToOrgDate)$/
    )
  ) {
    aValue = aValue ? aValue.seconds || -Infinity : -Infinity;
    bValue = bValue ? bValue.seconds || -Infinity : -Infinity;
  } else if (typeof aValue === "string" && typeof bValue === "string") {
    return aValue.localeCompare(bValue, undefined, { sensitivity: "base" });
  }

  //  console.log("index orderby:", orderBy, "aValue:", aValue, "bValue:", bValue);
  // Custom sorting for approvalStatus.updatedAt - sort by timestamp directly
  if (orderBy === "approvalStatus.updatedAt") {
    const aUpdatedAt = a.approvalStatus?.updatedAt ? a.approvalStatus.updatedAt.seconds || -Infinity : -Infinity;
    const bUpdatedAt = b.approvalStatus?.updatedAt ? b.approvalStatus.updatedAt.seconds || -Infinity : -Infinity;
    return bUpdatedAt - aUpdatedAt; // Descending order (newest first)
  }

  // Fallback for null or undefined values
  if (aValue == null && bValue != null) return 1;
  if (aValue != null && bValue == null) return -1;
  if (aValue == null && bValue == null) return 0;

  // Numeric and boolean comparison
  if (aValue < bValue) return -1;
  if (aValue > bValue) return 1;
  return 0;
}

export function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

export function stableSort(array, comparator) {
  const stabilizedThis = array && array?.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const permissions = {
  general: {
    super: [
      "Create/Modify/Delete Gen Super and Manager Admins",
      "View all Gen Admins",
      "View all Org Admins",
      "Create/Modify/Delete Gen Standard and Moderator",
      "Modify a User status with Moderation workflow",
      "Modify a QuickTale status with Moderation workflow",
      "Modify a Reaction status with Moderation workflow",
      "Modify an Album status with Moderation workflow",
      "Modify a User data fields",
      "Modify a QuickTale data fields",
      "Modify a Reaction data fields",
      "Modify an Album data fields",
      "Create an Org",
      "Login to Gen Admin Panel",
      "Login to Org Admin Panel",
      "View Users",
      "Create/Modify/Delete Org Super and Manager",
      "Create/Modify/Delete Org Standard and Moderator",
      "Create/Modify/Delete Org Areas",
      "Approve/Assign Status to QuickTales for Orgs",
      "Approve/Assign Status to Albums for Orgs",
      "Assign QuickTales and Albums to Areas",
      "Approve/Assign Status to Reactions",
      "Approve Contributors",
      "Manage Org Profile",
      "Subscribe (not implemented yet)",
    ],
    manager: [
      "View all Gen Admins",
      "View all Org Admins",
      "Create/Modify/Delete Gen Standard and Moderator",
      "Modify a User status with Moderation workflow",
      "Modify a QuickTale status with Moderation workflow",
      "Modify a Reaction status with Moderation workflow",
      "Modify an Album status with Moderation workflow",
      "Modify a User data fields",
      "Modify a QuickTale data fields",
      "Modify a Reaction data fields",
      "Modify an Album data fields",
      "Create an Org",
      "Login to Gen Admin Panel",
      "Login to Org Admin Panel",
      "View Users",
      "Create/Modify/Delete Org Super and Manager",
      "Create/Modify/Delete Org Standard and Moderator",
      "Create/Modify/Delete Org Areas",
      "Approve/Assign Status to QuickTales for Orgs",
      "Approve/Assign Status to Albums for Orgs",
      "Assign QuickTales and Albums to Areas",
      "Approve/Assign Status to Reactions",
      "Approve Contributors",
      "Manage Org Profile",
      "Subscribe (not implemented yet)",
    ],
    standard: [
      "View all Gen Admins",
      "View all Org Admins",
      "Modify a User status with Moderation workflow",
      "Modify a QuickTale status with Moderation workflow",
      "Modify a Reaction status with Moderation workflow",
      "Modify an Album status with Moderation workflow",
      "Modify a User data fields",
      "Modify a QuickTale data fields",
      "Modify a Reaction data fields",
      "Modify an Album data fields",
      "Login to Gen Admin Panel",
      "Login to Org Admin Panel",
      "View Users",
      "Approve/Assign Status to QuickTales for Orgs",
      "Approve/Assign Status to Albums for Orgs",
      "Assign QuickTales and Albums to Areas",
      "Approve/Assign Status to Reactions",
      "Approve Contributors",
      "Manage Org Profile",
      "Subscribe (not implemented yet)",
    ],
    moderator: [
      "View all Gen Admins",
      "View all Org Admins",
      "Modify a User status with Moderation workflow",
      "Modify a QuickTale status with Moderation workflow",
      "Modify a Reaction status with Moderation workflow",
      "Modify an Album status with Moderation workflow",
      "Modify a User data fields",
      "Modify a QuickTale data fields",
      "Modify a Reaction data fields",
      "Modify an Album data fields",
      "Login to Gen Admin Panel",
      "Login to Org Admin Panel",
      "View Users",
      "Approve/Assign Status to QuickTales for Orgs",
      "Approve/Assign Status to Albums for Orgs",
      "Assign QuickTales and Albums to Areas",
      "Approve/Assign Status to Reactions",
      "Approve Contributors",
      "Manage Org Profile",
      "Subscribe (not implemented yet)",
    ],
  },
  organization: {
    super: [
      "View all Org Admins",
      "Modify a User data fields",
      "Modify a QuickTale data fields",
      "Modify a Reaction data fields",
      "Modify an Album data fields",
      "Create an Org",
      "Login to Org Admin Panel",
      "View Users",
      "Create/Modify/Delete Org Super and Manager",
      "Create/Modify/Delete Org Standard and Moderator",
      "Create/Modify/Delete Org Areas",
      "Approve/Assign Status to QuickTales for Orgs",
      "Approve/Assign Status to Albums for Orgs",
      "Assign QuickTales and Albums to Areas",
      "Approve/Assign Status to Reactions",
      "Approve Contributors",
      "Manage Org Profile",
      "Subscribe (not implemented yet)",
    ],
    manager: [
      "View all Org Admins",
      "Modify a User data fields",
      "Modify a QuickTale data fields",
      "Modify a Reaction data fields",
      "Modify an Album data fields",
      "Create an Org",
      "Login to Org Admin Panel",
      "View Users",
      "Create/Modify/Delete Org Super and Manager",
      "Create/Modify/Delete Org Standard and Moderator",
      "Create/Modify/Delete Org Areas",
      "Approve/Assign Status to QuickTales for Orgs",
      "Approve/Assign Status to Albums for Orgs",
      "Assign QuickTales and Albums to Areas",
      "Approve/Assign Status to Reactions",
      "Approve Contributors",
      "Manage Org Profile",
      "Subscribe (not implemented yet)",
    ],
    standard: [
      "View all Org Admins",
      "Modify a User data fields",
      "Modify a QuickTale data fields",
      "Modify a Reaction data fields",
      "Modify an Album data fields",
      "Login to Org Admin Panel",
      "View Users",
      "Approve/Assign Status to QuickTales for Orgs",
      "Approve/Assign Status to Albums for Orgs",
      "Assign QuickTales and Albums to Areas",
      "Approve/Assign Status to Reactions",
      "Approve Contributors",
      "Manage Org Profile",
      "Subscribe (not implemented yet)",
    ],
  },
};

export const hasPermission = (adminType, role, action) => {
  return (
    permissions[adminType] &&
    permissions[adminType][role] &&
    permissions[adminType][role].includes(action)
  );
};

//Number of Reactions per quick tale data

export const reactionsPerQuictalesData = [
  ["", ""],
  ["Phychic Body Grotto at", 140],
  ["A Park Is By The People at", 110],
  ["Los Angeles State Historic", 150],
  ["Roundhouse Bridge at", 63],
  ["Origins at LASHP", 70],
  ["Zanja Modre at LASHP", 70],
  ["Park intro at LASHP", 70],
  ["The Tongva at LASHP ", 70],
];

//Number of Reactions per quick tale options
export const reactionsPerQuictalesOptions = {
  title: `${dateRange}`,
  // title: `Sep 1 - Sep 30 2023`,
  titleTextStyle: {
    color: "#595959", // Change the text color
    fontSize: 14, // Change the font size
    bold: true, // Make the title bold
    fontFamily: "Avenir Book, sans-serif",
  },
  // chartArea: { width: "40%", },
  // chartArea: { width: "100%" },
  fontFamily: "Avenir Book, sans-serif",
  colors: ["#B14EE0"],
  legend: { position: "none" },
  bar: { groupWidth: "30%" },
  isStacked: true,
  annotations: {
    textStyle: {
      fontSize: 12, // Adjust the font size of labels
      color: "#595959", // Adjust the text color of labels
      fontFamily: "Avenir Book, sans-serif",
    },
  },
};

//Number of Listeners per quick tale data
export const listenersPerQuictalesData = [
  ["", ""],
  ["The Tongva at LASHP ", 750],
  ["Zanja Modre at LASHP", 700],
  ["Los Angeles State Historic", 200],
  ["Park intro at LASHP", 400],
  ["Phychic Body Grotto at", 450],
  ["A Park Is By The People at", 500],
  ["Roundhouse Bridge at", 600],
  ["Origins at LASHP", 610],
];

//Number of Listeners per quick tale options
export const listenersPerQuictalesOptions = {
  title: `${dateRange}`,
  // title: `Sep 1 - Sep 30 2023`,
  titleTextStyle: {
    color: "#595959", // Change the text color
    fontSize: 14, // Change the font size
    bold: true, // Make the title bold
    fontFamily: "Avenir Book, sans-serif",
  },
  fontFamily: "Avenir Book, sans-serif",
  // chartArea: { width: "40%", },
  // chartArea: { width: "100%" },
  colors: ["#0AB2EE"],
  legend: { position: "none" },
  bar: { groupWidth: "30%" },
  isStacked: true,
  annotations: {
    textStyle: {
      fontSize: 12, // Adjust the font size of labels
      color: "#595959", // Adjust the text color of labels
      fontFamily: "Avenir Book, sans-serif",
    },
  },
};

//Listeners by locations data
export const listenersByLocationsData = [
  ["", ""],
  ["On Premise", 30],
  ["US", 5],
  ["Canada", 2],
  ["Maxico", 2],
  ["Europe", 4],
  ["Asia", 1],
  ["South America", 3],
];

//Number of Listeners per quick tale options
export const listenersByLocationsOptions = {
  title: `${dateRange}`,
  // title: `Sep 1 - Sep 30 2023`,
  titleTextStyle: {
    color: "#595959", // Change the text color
    fontSize: 14, // Change the font size
    bold: true, // Make the title bold
    paddingLeft: 40,
    textAlign: "center",
    fontFamily: "Avenir Book, sans-serif",
  },
  pieSliceText: "none",
  fontFamily: "Avenir Book, sans-serif",
  // tooltip: { trigger: "none" },
  slices: {
    0: { color: "#0AB2EE" },
    1: { color: "#EC7B38" },
    2: { color: "#A5A5A5" },
    3: { color: "#FFBE25" },
    4: { color: "#5B9DD3" },
    5: { color: "#72AB4C" },
    6: { color: "#254677" },
  },
};

//monthly active listeners data
export const monthlyActiveListenersData = [
  ["", ""],
  ["Jul", 470],
  ["Aug", 630],
  ["Sep", 855],
];

//monthly active listeners options
export const monthlyActiveListenersOptions = {
  chart: {
    // title: `Sep 1 - Sep 30 2023`,
    // subtitle: "Sales, Expenses, and Profit: 2014-2017",
    colors: ["#0AB2EE"],
    fontFamily: "Avenir Book, sans-serif",
    legend: { position: "none" },
    bars: { groupWidth: "30%", fontFamily: "Avenir Book, sans-serif" },
    isStacked: true,
  },
};

//ave % Of Quictales Listened data
export const aveOfQuictalesListenedData = [
  ["", ""],
  ["Park intro at LASHP", 750],
  ["Los Angeles State Historic", 700],
  ["Phychic Body Grotto at", 710],
  ["Roundhouse Bridge at", 600],
  ["Origins at LASHP", 550],
  ["A Park Is By The People at", 500],
  ["The Tongva at LASHP ", 450],
  ["Zanja Modre at LASHP", 400],
];

//ave % Of Quictales Listened options
export const aveOfQuictalesListenedOptions = {
  title: `${dateRange}`,
  // title: `Sep 1 - Sep 30 2023`,
  titleTextStyle: {
    color: "#595959", // Change the text color
    fontSize: 14, // Change the font size
    bold: true, // Make the title bold
    fontFamily: "Avenir Book, sans-serif",
  },
  // chartArea: { width: "40%", },
  // chartArea: { width: "100%" },
  colors: ["#0AB2EE"],
  fontFamily: "Avenir Book, sans-serif",
  legend: { position: "none" },
  bar: { groupWidth: "30%" },
  isStacked: true,
  annotations: {
    textStyle: {
      fontSize: 12, // Adjust the font size of labels
      color: "#595959", // Adjust the text color of labels
      fontFamily: "Avenir Book, sans-serif",
    },
  },
};

//Daily Active Listeners data
export const dailyActiveListenersData = [
  ["", ""],
  [0, 20],
  [1, 30],
  [2, 25],
  [3, 35],
  [4, 38],
  [5, 35],
  [6, 37],
  [7, 36],
  [8, 35],
  [9, 34],
  [10, 38],
];

//Daily Active Listeners options
export const dailyActiveListenersOptions = {
  // chart: {
  //   title: "Average Temperatures and Daylight in Iceland Throughout the Year",
  // },
  legend: { position: "none" },
  colors: ["#0AB2EE"],
  fontFamily: "Avenir Book, sans-serif",
  // width: "80%",
  // series: {
  //   // Gives each series an axis name that matches the Y-axis below.
  //   0: { axis: "Temps" },
  //   1: { axis: "Daylight" },
  // },
  // axes: {
  //   // Adds labels to each axis; they don't have to match the axis names.
  //   y: {
  //     Temps: { label: "Temps (Celsius)" },
  //     Daylight: { label: "Daylight" },
  //   },
  // },
};

export const QuicktalesInOrgTableHeadCells = [
  {
    id: "title",
    numeric: false,
    disablePadding: true,
    label: "QT Title",
    width: 300,
  },
  {
    id: "photo",
    numeric: false,
    disablePadding: true,
    label: "Photo",
    width: 90,
  },
  {
    id: "audio",
    numeric: false,
    disablePadding: true,
    label: "Audio",
    width: 90,
  },
  {
    id: "areaNameResolved",
    numeric: false,
    disablePadding: true,
    label: "Area",
    width: 170,
  },
  {
    id: "id",
    numeric: false,
    disablePadding: true,
    label: "QT ID",
    width: 100,
  },
  {
    id: "createdByData.userName",
    numeric: false,
    disablePadding: true,
    label: "Created By",
    width: 140,
  },

  {
    id: "narratorData.userName",
    numeric: false,
    disablePadding: true,
    label: "Told By",
    width: 120,
  },
  {
    id: "status",
    numeric: false,
    disablePadding: true,
    label: "Who Can Listen",
    width: 150,
  },
  {
    id: "isDraft",
    numeric: false,
    disablePadding: true,
    label: "QT Status",
    width: 110,
  },
  {
    id: "audioLength",
    numeric: false,
    disablePadding: true,
    label: "Length",
    width: 100,
  },
  {
    id: "approvalStatus.status",
    numeric: false,
    disablePadding: true,
    label: "QT Org Status",
    // label: "QT Status",
    width: 170,
  },
  {
    id: "approvalStatus.updatedAt",
    numeric: false,
    disablePadding: true,
    label: "Status Change Date",
    // label: "Modified Status Date",
    width: 180,
  },
];

export const ContributorInvitesTableHeadCells = [
  {
    id: "organizationName",
    numeric: false,
    disablePadding: true,
    label: "Organization",
    width: 250,
  },
  {
    id: "createdAt",
    numeric: false,
    disablePadding: true,
    label: "Create Date",
    width: 170,
  },
  {
    id: "status",
    numeric: false,
    disablePadding: true,
    label: "Status",
    width: 140,
  },
  {
    id: "updatedAt",
    numeric: false,
    disablePadding: true,
    label: "Status Date",
    width: 170,
  },
];

export const QuicktalesContributorsTableHeadCells = [
  {
    id: "firstName",
    numeric: false,
    disablePadding: true,
    label: "First Name",
    width: 170,
  },
  {
    id: "lastName",
    numeric: false,
    disablePadding: true,
    label: "Last Name",
    width: 140,
  },
  {
    id: "userName",
    numeric: false,
    disablePadding: true,
    label: "Username",
    width: 140,
  },
  {
    // id: "invitationToOrgDate",
    id: "createdAt",
    numeric: false,
    disablePadding: true,
    label: "Date Sent",
    width: 170,
  },
  {
    id: "addedToOrgDate",
    numeric: false,
    disablePadding: true,
    label: "Date Updated",
    width: 170,
  },
  {
    id: "status",
    numeric: false,
    disablePadding: true,
    label: "Status",
    width: 140,
  },
];

export const QuicktalesAddContributorsTableHeadCells = [
  {
    id: "FirstName",
    numeric: false,
    disablePadding: true,
    label: "First Name",
  },
  // {
  //   id: "photo",
  //   numeric: false,
  //   disablePadding: true,
  //   label: "Photo",
  // },
  // {
  //   id: "audio",
  //   numeric: false,
  //   disablePadding: true,
  //   label: "Audio",
  // },
  // {
  //   id: "qtId",
  //   numeric: false,
  //   disablePadding: true,
  //   label: "QT ID",
  // },
  {
    id: "lastName",
    numeric: false,
    disablePadding: true,
    label: "Last Name",
  },
  {
    id: "username",
    numeric: false,
    disablePadding: true,
    label: "Username",
  },

  // {
  //   id: "status",
  //   numeric: false,
  //   disablePadding: true,
  //   label: "Status",
  // },
  // {
  //   id: "dateSent",
  //   numeric: false,
  //   disablePadding: true,
  //   label: "Date Sent",
  // },
  // {
  //   id: "dateUpdated",
  //   numeric: false,
  //   disablePadding: true,
  //   label: "Date Updated",
  // },
];
export function createQuicktalesInOrgData(
  id,
  qtTitle,
  photo,
  audio,
  qtId,
  createdBy,
  toldBy,
  whoCanListen,
  qtStatus,
  reportedStatus,
  description,
  tags,
  length,
  noOfLikes,
  noOfReactions,
  noOfShares,
  noOfSaves
) {
  return {
    id,
    qtTitle,
    photo,
    audio,
    qtId,
    createdBy,
    toldBy,
    whoCanListen,
    qtStatus,
    reportedStatus,
    description,
    tags,
    length,
    noOfLikes,
    noOfReactions,
    noOfShares,
    noOfSaves,
  };
}

function createAddContribtuorData(
  id,
  // qtTitle,
  firstName,
  lastName,
  userName

  // photo,
  // audio
  // qtId,
  // createdBy,
  // toldBy,
  // whoCanListen,
  // qtStatus,
  // description,
  // tags,
  // length,
  // noOfLikes,
  // noOfReactions,
  // noOfShares,
  // noOfSaves
) {
  return {
    id,
    firstName,
    lastName,
    userName,
    // qtTitle,
    // photo,
    // audio,
    // qtId,
    // createdBy,
    // toldBy,
    // whoCanListen,
    // qtStatus,
    // description,
    // tags,
    // length,
    // noOfLikes,
    // noOfReactions,
    // noOfShares,
    // noOfSaves,
  };
}
export const AddContributorsData = [
  createAddContribtuorData(
    1,
    "Harry",
    "Sarah Michael",
    "Username"

    // "image",
    // "audio",
    // "Samson",
    // "Accepted",
    // "12/3/2023",
    // "12/3/2023",
    // "LASHP is a 32-acre California State Park in the heart of LA that offers beautiful views of downtown and creative public events.",
    // "Park, History, LA",
    // "2:30",
    // 10,
    // 20,
    // 30,
    // 40
  ),
];

export const QuicktalesContributorsData = [
  createQuicktalesInOrgData(
    1,
    "Harry",
    "image",
    "audio",
    "Samson",
    "Sarah Michael",
    "Accepted",
    "12/3/2023",
    "12/3/2023",
    "LASHP is a 32-acre California State Park in the heart of LA that offers beautiful views of downtown and creative public events.",
    "Park, History, LA",
    "2:30",
    10,
    20,
    30,
    40
  ),
  createQuicktalesInOrgData(
    2,
    "Potter",
    "image",
    "audio",
    "Laura",
    "Potter Laura",
    "Accepted",
    "02/3/2023",
    "01/3/2023",
    "LASHP is a 32-acre California State Park in the heart of LA that offers beautiful views of downtown and creative public events.",
    "Park, History, LA",
    "2:30",
    10,
    20,
    30,
    40
  ),
  createQuicktalesInOrgData(
    3,
    "Dwayne",
    "image",
    "audio",
    "Johnson",
    "Dwayne Johnson",
    "Accepted",
    "19/5/2021",
    "01/2/2023",
    "LASHP is a 32-acre California State Park in the heart of LA that offers beautiful views of downtown and creative public events.",
    "Park, History, LA",
    "2:30",
    10,
    20,
    30,
    40
  ),
  createQuicktalesInOrgData(
    3,
    "David",
    "image",
    "audio",
    "Johnson",
    "David Johnson",
    "Pending",
    "19/5/2021",
    "01/2/2023",
    "LASHP is a 32-acre California State Park in the heart of LA that offers beautiful views of downtown and creative public events.",
    "Park, History, LA",
    "2:30",
    10,
    20,
    30,
    40
  ),
];

export const QuicktalesInOrgData = [
  createQuicktalesInOrgData(
    1,
    "Los Angeles State Historic Park",
    "image",
    "audio",
    "12345",
    "Sarah Michael",
    "Sarah Michael",
    "Public",
    "Pending",
    "Pending",
    "LASHP is a 32-acre California State Park in the heart of LA that offers beautiful views of downtown and creative public events.",
    "Park, History, LA",
    "2:30",
    10,
    20,
    30,
    40
  ),
  createQuicktalesInOrgData(
    2,
    "Park Intro at LASHP",
    "image",
    "audio",
    "12345",
    "Josh Powell",
    "Josh Powell",
    "Public",
    "Pending",
    "Resolved",
    "LASHP is a 32-acre California State Park in the heart of LA that offers beautiful views of downtown and creative public events.",
    "Park, History, LA",
    "2:30",
    10,
    20,
    30,
    40
  ),
  createQuicktalesInOrgData(
    3,
    "A Park is By the People at LASHP",
    "image",
    "audio",
    "12345",
    "Olivia Martinez",
    "Olivia Martinez",
    "Public",
    "Pending",
    "Flagged",
    "LASHP is a 32-acre California State Park in the heart of LA that offers beautiful views of downtown and creative public events.",
    "Park, History, LA",
    "2:30",
    10,
    20,
    30,
    40
  ),
  createQuicktalesInOrgData(
    4,
    "Zanja Madre At LASHP",
    "image",
    "audio",
    "12345",
    "Linda Pham",
    "Linda Pham",
    "Public",
    "Approved",
    "Resolved",
    "LASHP is a 32-acre California State Park in the heart of LA that offers beautiful views of downtown and creative public events.",
    "Park, History, LA",
    "2:30",
    10,
    20,
    30,
    40
  ),
  createQuicktalesInOrgData(
    5,
    "Origins at LASHP",
    "image",
    "audio",
    "12345",
    "Benson Lee",
    "Benson Lee",
    "Private",
    "Approved",
    "Flagged",
    "LASHP is a 32-acre California State Park in the heart of LA that offers beautiful views of downtown and creative public events.",
    "Park, History, LA",
    "2:30",
    10,
    20,
    30,
    40
  ),
  createQuicktalesInOrgData(
    6,
    "The Tongva at LASHP",
    "image",
    "audio",
    "12345",
    "Oscar Ramos",
    "Oscar Ramos",
    "Private",
    "Approved",
    "Flagged",
    "LASHP is a 32-acre California State Park in the heart of LA that offers beautiful views of downtown and creative public events.",
    "Park, History, LA",
    "2:30",
    10,
    20,
    30,
    40
  ),
  createQuicktalesInOrgData(
    7,
    "Psychic body grotto at LASHP",
    "image",
    "audio",
    "12345",
    "Benson Lee",
    "Oscar Ramos",
    "Unpublished",
    "Approved",
    "In Review",
    "LASHP is a 32-acre California State Park in the heart of LA that offers beautiful views of downtown and creative public events.",
    "Park, History, LA",
    "2:30",
    10,
    20,
    30,
    40
  ),
  createQuicktalesInOrgData(
    8,
    "Roundhouse Bridge at LASHP",
    "image",
    "audio",
    "12345",
    "Benson Lee",
    "Oscar Ramos",
    "Unlisted",
    "Denied",
    "In Review",
    "LASHP is a 32-acre California State Park in the heart of LA that offers beautiful views of downtown and creative public events.",
    "Park, History, LA",
    "2:30",
    10,
    20,
    30,
    40
  ),
  createQuicktalesInOrgData(
    9,
    "Park Intro at LASHP",
    "image",
    "audio",
    "12345",
    "Josh Powell",
    "Josh Powell",
    "Public",
    "Pending",
    "In Review",
    "LASHP is a 32-acre California State Park in the heart of LA that offers beautiful views of downtown and creative public events.",
    "Park, History, LA",
    "2:30",
    10,
    20,
    30,
    40
  ),
  createQuicktalesInOrgData(
    10,
    "A Park is By the People at LASHP",
    "image",
    "audio",
    "12345",
    "Olivia Martinez",
    "Olivia Martinez",
    "Public",
    "Pending",
    "Flagged",
    "LASHP is a 32-acre California State Park in the heart of LA that offers beautiful views of downtown and creative public events.",
    "Park, History, LA",
    "2:30",
    10,
    20,
    30,
    40
  ),
  createQuicktalesInOrgData(
    11,
    "Zanja Madre At LASHP",
    "image",
    "audio",
    "12345",
    "Linda Pham",
    "Linda Pham",
    "Public",
    "Approved",
    "Flagged",
    "LASHP is a 32-acre California State Park in the heart of LA that offers beautiful views of downtown and creative public events.",
    "Park, History, LA",
    "2:30",
    10,
    20,
    30,
    40
  ),
  createQuicktalesInOrgData(
    12,
    "Origins at LASHP",
    "image",
    "audio",
    "12345",
    "Benson Lee",
    "Benson Lee",
    "Private",
    "Approved",
    "Flagged",
    "LASHP is a 32-acre California State Park in the heart of LA that offers beautiful views of downtown and creative public events.",
    "Park, History, LA",
    "2:30",
    10,
    20,
    30,
    40
  ),
  createQuicktalesInOrgData(
    13,
    "The Tongva at LASHP",
    "image",
    "audio",
    "12345",
    "Oscar Ramos",
    "Oscar Ramos",
    "Private",
    "Approved",
    "Flagged",
    "LASHP is a 32-acre California State Park in the heart of LA that offers beautiful views of downtown and creative public events.",
    "Park, History, LA",
    "2:30",
    10,
    20,
    30,
    40
  ),
  createQuicktalesInOrgData(
    14,
    "The Tongva at LASHP",
    "image",
    "audio",
    "12345",
    "Oscar Ramos",
    "Oscar Ramos",
    "Private",
    "Approved",
    "Flagged",
    "LASHP is a 32-acre California State Park in the heart of LA that offers beautiful views of downtown and creative public events.",
    "Park, History, LA",
    "2:30",
    10,
    20,
    30,
    40
  ),
  createQuicktalesInOrgData(
    15,
    "Psychic body grotto at LASHP",
    "image",
    "audio",
    "12345",
    "Benson Lee",
    "Oscar Ramos",
    "Unpublished",
    "Approved",
    "Pending",
    "LASHP is a 32-acre California State Park in the heart of LA that offers beautiful views of downtown and creative public events.",
    "Park, History, LA",
    "2:30",
    10,
    20,
    30,
    40
  ),
  createQuicktalesInOrgData(
    16,
    "Roundhouse Bridge at LASHP",
    "image",
    "audio",
    "12345",
    "Benson Lee",
    "Oscar Ramos",
    "Unlisted",
    "Denied",
    "Flagged",
    "LASHP is a 32-acre California State Park in the heart of LA that offers beautiful views of downtown and creative public events.",
    "Park, History, LA",
    "2:30",
    10,
    20,
    30,
    40
  ),
  createQuicktalesInOrgData(
    17,
    "Park Intro at LASHP",
    "image",
    "audio",
    "12345",
    "Josh Powell",
    "Josh Powell",
    "Public",
    "Pending",
    "Pending",
    "LASHP is a 32-acre California State Park in the heart of LA that offers beautiful views of downtown and creative public events.",
    "Park, History, LA",
    "2:30",
    10,
    20,
    30,
    40
  ),
];

export const ReactionsInOrgTableHeadCells = [
  {
    id: "quicktaleData.title",
    numeric: false,
    disablePadding: true,
    label: "QuickTales Title",
    width: 200,
  },

  {
    id: "userData.userName",
    numeric: false,
    disablePadding: true,
    label: "Reaction By",
    width: 170,
  },
  {
    id: "audio",
    numeric: false,
    disablePadding: true,
    label: "Reaction Audio",
    width: 120,
  },
  {
    id: "id",
    numeric: false,
    disablePadding: true,
    label: "Reaction ID",
    width: 120,
  },
  {
    id: "status",
    numeric: false,
    disablePadding: true,
    label: "Reaction Status",
    width: 170,
  },

  {
    id: "createdAt",
    numeric: false,
    disablePadding: true,
    label: "Creation Date",
    width: 170,
  },
  {
    id: "quicktaleData.audioLength",
    numeric: false,
    disablePadding: true,
    label: "Length",
    width: 100,
  },
  {
    id: "photo",
    numeric: false,
    disablePadding: true,
    label: "Photo",
    width: 90,
  },
  {
    id: "quicktale",
    numeric: false,
    disablePadding: true,
    label: "QT ID",
    width: 120,
  },
  {
    id: "qtCreatedByData.userName",
    numeric: false,
    disablePadding: true,
    label: "QT Created By",
    width: 220,
  },
];

function createReactionsInOrgData(
  id,
  qtTitle,
  userName,
  userHandle,
  audio,
  reactionId,
  status,
  createdBy,
  createdDate,
  length,
  photo
) {
  return {
    id,
    qtTitle,
    userName,
    userHandle,
    audio,
    reactionId,
    status,
    createdBy,
    createdDate,
    length,
    photo,
  };
}

export const ReactionsInOrgData = [
  createReactionsInOrgData(
    1,
    "Los Angeles State Historic Park",
    "Sarah Michael",
    "Sarah_123",
    "audio",
    "12345",
    "Pending",
    "Sarah Michael",
    "Sep 1, 2021",
    "2:30",
    "image"
  ),
  createReactionsInOrgData(
    2,
    "Park Intro at LASHP",
    "Sarah Michael",
    "Sarah_123",
    "audio",
    "12345",
    "Pending",
    "Sarah Michael",
    "Sep 1, 2021",
    "2:30",
    "image"
  ),
  createReactionsInOrgData(
    3,
    "A Park is By the People at LASHP",
    "Sarah Michael",
    "Sarah_123",
    "audio",
    "12345",
    "Approved",
    "Sarah Michael",
    "Sep 1, 2021",
    "2:30",
    "image"
  ),
  createReactionsInOrgData(
    4,
    "Zanja Madre At LASHP",
    "Sarah Michael",
    "Sarah_123",
    "audio",
    "12345",
    "Approved",
    "Sarah Michael",
    "Sep 1, 2021",
    "2:30",
    "image"
  ),
  createReactionsInOrgData(
    5,
    "Origins at LASHP",
    "Sarah Michael",
    "Sarah_123",
    "audio",
    "12345",
    "Denied",
    "Sarah Michael",
    "Sep 1, 2021",
    "2:30",
    "image"
  ),
  createReactionsInOrgData(
    6,
    "The Tongva at LASHP",
    "Sarah Michael",
    "Sarah_123",
    "audio",
    "12345",
    "Denied",
    "Sarah Michael",
    "Sep 1, 2021",
    "2:30",
    "image"
  ),
  createReactionsInOrgData(
    7,
    "Psychic body grotto at LASHP",
    "Sarah Michael",
    "Sarah_123",
    "audio",
    "12345",
    "Removed",
    "Sarah Michael",
    "Sep 1, 2021",
    "2:30",
    "image"
  ),
  createReactionsInOrgData(
    8,
    "Roundhouse Bridge at LASHP",
    "Sarah Michael",
    "Sarah_123",
    "audio",
    "12345",
    "Pending",
    "Sarah Michael",
    "Sep 1, 2021",
    "2:30",
    "image"
  ),
  createReactionsInOrgData(
    9,
    "Park Intro at LASHP",
    "Sarah Michael",
    "Sarah_123",
    "audio",
    "12345",
    "Denied",
    "Sarah Michael",
    "Sep 1, 2021",
    "2:30",
    "image"
  ),
  createReactionsInOrgData(
    10,
    "A Park is By the People at LASHP",
    "Sarah Michael",
    "Sarah_123",
    "audio",
    "12345",
    "Pending",
    "Sarah Michael",
    "Sep 1, 2021",
    "2:30",
    "image"
  ),
  createReactionsInOrgData(
    11,
    "Los Angeles State Historic Park",
    "Sarah Michael",
    "Sarah_123",
    "audio",
    "12345",
    "Approved",
    "Sarah Michael",
    "Sep 1, 2021",
    "2:30",
    "image"
  ),
  createReactionsInOrgData(
    12,
    "Park Intro at LASHP",
    "Sarah Michael",
    "Sarah_123",
    "audio",
    "12345",
    "Pending",
    "Sarah Michael",
    "Sep 1, 2021",
    "2:30",
    "image"
  ),
  createReactionsInOrgData(
    13,
    "A Park is By the People at LASHP",
    "Sarah Michael",
    "Sarah_123",
    "audio",
    "12345",
    "Pending",
    "Sarah Michael",
    "Sep 1, 2021",
    "2:30",
    "image"
  ),
  createReactionsInOrgData(
    14,
    "Zanja Madre At LASHP",
    "Sarah Michael",
    "Sarah_123",
    "audio",
    "12345",
    "Denied",
    "Sarah Michael",
    "Sep 1, 2021",
    "2:30",
    "image"
  ),
  createReactionsInOrgData(
    15,
    "Origins at LASHP",
    "Sarah Michael",
    "Sarah_123",
    "audio",
    "12345",
    "Denied",
    "Sarah Michael",
    "Sep 1, 2021",
    "2:30",
    "image"
  ),
  createReactionsInOrgData(
    16,
    "The Tongva at LASHP",
    "Sarah Michael",
    "Sarah_123",
    "audio",
    "12345",
    "Removed",
    "Sarah Michael",
    "Sep 1, 2021",
    "2:30",
    "image"
  ),
  createReactionsInOrgData(
    17,
    "Psychic body grotto at LASHP",
    "Sarah Michael",
    "Sarah_123",
    "audio",
    "12345",
    "Pending",
    "Sarah Michael",
    "Sep 1, 2021",
    "2:30",
    "image"
  ),
  createReactionsInOrgData(
    18,
    "Roundhouse Bridge at LASHP",
    "Sarah Michael",
    "Sarah_123",
    "audio",
    "12345",
    "Removed",
    "Sarah Michael",
    "Sep 1, 2021",
    "2:30",
    "image"
  ),
  createReactionsInOrgData(
    19,
    "Park Intro at LASHP",
    "Sarah Michael",
    "Sarah_123",
    "audio",
    "12345",
    "Pending",
    "Sarah Michael",
    "Sep 1, 2021",
    "2:30",
    "image"
  ),
  createReactionsInOrgData(
    20,
    "A Park is By the People at LASHP",
    "Sarah Michael",
    "Sarah_123",
    "audio",
    "12345",
    "Pending",
    "Sarah Michael",
    "Sep 1, 2021",
    "2:30",
    "image"
  ),
];

export const AlbumsInOrgTableHeadCells = [
  {
    id: "title",
    numeric: false,
    disablePadding: true,
    label: "Album Title",
    width: 200,
  },
  {
    id: "photo",
    numeric: false,
    disablePadding: true,
    label: "Album Photo",
    width: 120,
  },
  {
    id: "id",
    numeric: false,
    disablePadding: true,
    label: "Album ID",
    width: 120,
  },
  {
    id: "userData.userName",
    numeric: false,
    disablePadding: true,
    label: "Created By",
    width: 160,
  },
  {
    id: "description",
    numeric: false,
    disablePadding: true,
    label: "Album Description",
    width: 190,
  },
  {
    id: "privacy",
    numeric: false,
    disablePadding: true,
    label: "Who Can Listen",
    width: 150,
  },
  {
    id: "createdAt",
    numeric: false,
    disablePadding: true,
    label: "Creation Date",
    width: 170,
  },

  {
    id: "quicktales",
    numeric: false,
    disablePadding: true,
    label: "# of QT in Album",
    width: 170,
  },
  {
    id: "length",
    numeric: false,
    disablePadding: true,
    label: "Length",
    width: 100,
  },
  // {
  //   id: "length",
  //   numeric: false,
  //   disablePadding: true,
  //   label: "Length",
  //   width: 120,
  // },
  // {
  //   id: "noOfLikes",
  //   numeric: false,
  //   disablePadding: true,
  //   label: "# of Likes",
  // },
  // {
  //   id: "noOfShares",
  //   numeric: false,
  //   disablePadding: true,
  //   label: "# of Shares",
  // },
  // {
  //   id: "noOfSaves",
  //   numeric: false,
  //   disablePadding: true,
  //   label: "# of Saves",
  // },
];

function createAlbumsInOrgData(
  id,
  albumTitle,
  photo,
  albumId,
  createdBy,
  description,
  whoCanListen,
  createdDate,
  noOfLikes,
  noOfShares,
  noOfSaves,
  length,
  noOfQTInAlbum
) {
  return {
    id,
    albumTitle,
    photo,
    albumId,
    createdBy,
    description,
    whoCanListen,
    createdDate,
    noOfLikes,
    noOfShares,
    noOfSaves,
    length,
    noOfQTInAlbum,
  };
}

export const AlbumsInOrgData = [
  createAlbumsInOrgData(
    1,
    "Los Angeles State Historic Park",
    "image",
    "12345",
    "Sarah Michael",
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam eleifend bibendum",
    "Public",
    "Sep 1, 2021",
    20,
    30,
    40,
    5,
    "5:30"
  ),
  createAlbumsInOrgData(
    2,
    "Park Intro at LASHP",
    "image",
    "12345",
    "Sarah Michael",
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam eleifend bibendum",
    "Public",
    "Sep 1, 2021",
    20,
    30,
    40,
    10,
    "5:30"
  ),
  createAlbumsInOrgData(
    3,
    "A Park is By the People at LASHP",
    "image",
    "12345",
    "Sarah Michael",
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam eleifend bibendum",
    "Public",
    "Sep 1, 2021",
    20,
    30,
    40,
    15,
    "5:30"
  ),
  createAlbumsInOrgData(
    4,
    "Zanja Madre At LASHP",
    "image",
    "12345",
    "Sarah Michael",
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam eleifend bibendum",
    "Private",
    "Sep 1, 2021",
    20,
    30,
    40,
    5,
    "5:30"
  ),
  createAlbumsInOrgData(
    5,
    "Origins at LASHP",
    "image",
    "12345",
    "Sarah Michael",
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam eleifend bibendum",
    "Private",
    "Sep 1, 2021",
    20,
    30,
    40,
    5,
    "5:30"
  ),
  createAlbumsInOrgData(
    6,
    "The Tongva at LASHP",
    "image",
    "12345",
    "Sarah Michael",
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam eleifend bibendum",
    "Unlisted",
    "Sep 1, 2021",
    20,
    30,
    40,
    5,
    "5:30"
  ),
  createAlbumsInOrgData(
    7,
    "Psychic body grotto at LASHP",
    "image",
    "12345",
    "Sarah Michael",
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam eleifend bibendum",
    "Public",
    "Sep 1, 2021",
    20,
    30,
    40,
    5,
    "5:30"
  ),
  createAlbumsInOrgData(
    8,
    "Roundhouse Bridge at LASHP",
    "image",
    "12345",
    "Sarah Michael",
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam eleifend bibendum",
    "Public",
    "Sep 1, 2021",
    20,
    30,
    40,
    5,
    "5:30"
  ),
  createAlbumsInOrgData(
    9,
    "Los Angeles State Historic Park",
    "image",
    "12345",
    "Sarah Michael",
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam eleifend bibendum",
    "Public",
    "Sep 1, 2021",
    20,
    30,
    40,
    5,
    "5:30"
  ),
  createAlbumsInOrgData(
    10,
    "The Tongva at LASHP",
    "image",
    "12345",
    "Sarah Michael",
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam eleifend bibendum",
    "Public",
    "Sep 1, 2021",
    20,
    30,
    40,
    5,
    "5:30"
  ),
  createAlbumsInOrgData(
    11,
    "Psychic body grotto at LASHP",
    "image",
    "12345",
    "Sarah Michael",
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam eleifend bibendum",
    "Public",
    "Sep 1, 2021",
    20,
    30,
    40,
    5,
    "5:30"
  ),
  createAlbumsInOrgData(
    12,
    "Roundhouse Bridge at LASHP",
    "image",
    "12345",
    "Sarah Michael",
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam eleifend bibendum",
    "Public",
    "Sep 1, 2021",
    20,
    30,
    40,
    5,
    "5:30"
  ),
];

export const QuicktalesTableHeadCells = [
    {
    id: "position",
    numeric: false,
    disablePadding: true,
    label: "Position",
    width: 90,
  },
  {
    id: "title",
    numeric: false,
    disablePadding: true,
    label: "QT Title",
  },
  {
    id: "photo",
    numeric: false,
    disablePadding: true,
    label: "Photo",
    width: 90,
  },
  {
    id: "audio",
    numeric: false,
    disablePadding: true,
    label: "Audio",
    width: 90,
  },
  {
    id: "id",
    numeric: false,
    disablePadding: true,
    label: "QT ID",
    width: 220,
  },
  {
    id: "createdBy",
    numeric: false,
    disablePadding: true,
    label: "Created By",
    width: 140,
  },
  {
    id: "toldBy",
    numeric: false,
    disablePadding: true,
    label: "Told By",
    width: 140,
  },
  {
    id: "listenerType",
    numeric: false,
    disablePadding: true,
    label: "Who Can Listen",
    width: 150,
  },

  {
    id: "status",
    numeric: false,
    disablePadding: true,
    label: "QT Status",
    width: 100,
  },
    {
    id: "updatedAt",
    numeric: false,
    disablePadding: true,
    label: "Status Change Date",
    width: 180,
  },
  {
    id: "audioLength",
    numeric: false,
    disablePadding: true,
    label: "Length",
    width: 100,
  },
];
export const AreaAlbumsTableHeadCells = [
  {
    id: "title",
    numeric: false,
    disablePadding: true,
    label: "Album Title",
  },
  {
    id: "photo",
    numeric: false,
    disablePadding: true,
    label: "Photo",
  },
  {
    id: "id",
    numeric: false,
    disablePadding: true,
    label: "Album ID",
  },
  {
    id: "createdBy",
    numeric: false,
    disablePadding: true,
    label: "Created By",
  },

  {
    id: "privacy",
    numeric: false,
    disablePadding: true,
    label: "Who Can Listen",
    width: 150,
  },
    {
    id: "createdAt",
    numeric: false,
    disablePadding: true,
    label: "Creation Date",
  },
  {
    id: "position",
    numeric: false,
    disablePadding: true,
    label: "Position",
  },
];

// sz //
export const QuicktalesInAreaTableHeadCells = [
  {
    id: "qtTitle",
    numeric: false,
    disablePadding: true,
    label: "QT Title",
  },
  {
    id: "photo",
    numeric: false,
    disablePadding: true,
    label: "Photo",
  },
  {
    id: "audio",
    numeric: false,
    disablePadding: true,
    label: "Audio",
  },
  {
    id: "qtId",
    numeric: false,
    disablePadding: true,
    label: "QT ID",
  },
  {
    id: "createdBy",
    numeric: false,
    disablePadding: true,
    label: "Created By",
  },
  {
    id: "ToldBy",
    numeric: false,
    disablePadding: true,
    label: "Told By",
  },
  {
    id: "listenerType",
    numeric: false,
    disablePadding: true,
    label: "Who Can Listen",
    width: 150,
  },
  // {
  //   id: "createdDate",
  //   numeric: false,
  //   disablePadding: true,
  //   label: "Created Date",
  // },
  {
    id: "qtStatus",
    numeric: false,
    disablePadding: true,
    label: "QT Status",
    width: 170,
  },
  {
    id: "audioLength",
    numeric: false,
    disablePadding: true,
    label: "Length",
    width: 100,
  },
  {
    id: "position",
    numeric: false,
    disablePadding: true,
    label: "Position",
  },
];

function createQuicktalesInAlbumData(
  id,
  qtTitle,
  photo,
  audio,
  qtId,
  createdBy,
  createdDate,
  length,
  position
) {
  return {
    id,
    qtTitle,
    photo,
    audio,
    qtId,
    createdBy,
    createdDate,
    length,
    position,
  };
}

export const QuicktalesInAlbumData = [
  createQuicktalesInAlbumData(
    1,
    "Los Angeles State Historic Park",
    "image",
    "audio",
    "12345",
    "Sarah Michael",
    "12-13-2023",
    "2:30",
    1
  ),
  createQuicktalesInAlbumData(
    2,
    "Park Intro at LASHP",
    "image",
    "audio",
    "12345",
    "Josh Powell",
    "12-13-2023",
    "2:30",
    2
  ),
  createQuicktalesInAlbumData(
    3,
    "A Park is By the People at LASHP",
    "image",
    "audio",
    "12345",
    "Olivia Martinez",
    "12-13-2023",
    "2:30",
    3
  ),
  createQuicktalesInAlbumData(
    4,
    "Zanja Madre At LASHP",
    "image",
    "audio",
    "12345",
    "Linda Pham",
    "12-13-2023",
    "2:30",
    4
  ),
  createQuicktalesInAlbumData(
    5,
    "Origins at LASHP",
    "image",
    "audio",
    "12345",
    "Benson Lee",
    "12-13-2023",
    "2:30",
    5
  ),
  createQuicktalesInAlbumData(
    6,
    "The Tongva at LASHP",
    "image",
    "audio",
    "12345",
    "Oscar Ramos",
    "12-13-2023",
    "2:30",
    6
  ),
  createQuicktalesInAlbumData(
    7,
    "Psychic body grotto at LASHP",
    "image",
    "audio",
    "12345",
    "Benson Lee",
    "12-13-2023",
    "2:30",
    7
  ),
  createQuicktalesInAlbumData(
    8,
    "Roundhouse Bridge at LASHP",
    "image",
    "audio",
    "12345",
    "Benson Lee",
    "12-13-2023",
    "2:30",
    8
  ),
  createQuicktalesInAlbumData(
    9,
    "Park Intro at LASHP",
    "image",
    "audio",
    "12345",
    "Josh Powell",
    "12-13-2023",
    "2:30",
    9
  ),
  createQuicktalesInAlbumData(
    10,
    "A Park is By the People at LASHP",
    "image",
    "audio",
    "12345",
    "Olivia Martinez",
    "12-13-2023",
    "2:30",
    10
  ),
  createQuicktalesInAlbumData(
    11,
    "Zanja Madre At LASHP",
    "image",
    "audio",
    "12345",
    "Linda Pham",
    "12-13-2023",
    "2:30",
    11
  ),
  createQuicktalesInAlbumData(
    12,
    "Origins at LASHP",
    "image",
    "audio",
    "12345",
    "Benson Lee",
    "12-13-2023",
    "2:30",
    12
  ),
  createQuicktalesInAlbumData(
    13,
    "The Tongva at LASHP",
    "image",
    "audio",
    "12345",
    "Oscar Ramos",
    "12-13-2023",
    "2:30",
    13
  ),
  createQuicktalesInAlbumData(
    14,
    "The Tongva at LASHP",
    "image",
    "audio",
    "12345",
    "Oscar Ramos",
    "12-13-2023",
    "2:30",
    14
  ),
  createQuicktalesInAlbumData(
    15,
    "Psychic body grotto at LASHP",
    "image",
    "audio",
    "12345",
    "Benson Lee",
    "12-13-2023",
    "2:30",
    15
  ),
  createQuicktalesInAlbumData(
    16,
    "Roundhouse Bridge at LASHP",
    "image",
    "audio",
    "12345",
    "Benson Lee",
    "12-13-2023",
    "2:30",
    16
  ),
  createQuicktalesInAlbumData(
    17,
    "Park Intro at LASHP",
    "image",
    "audio",
    "12345",
    "Josh Powell",
    "12-13-2023",
    "2:30",
    17
  ),
];

export const AddQuicktalesToAlbumTableHeadCells = [
  {
    id: "title",
    numeric: false,
    disablePadding: true,
    label: "QT Title",
  },
  {
    id: "photo",
    numeric: false,
    disablePadding: true,
    label: "Photo",
    width: 90,
  },
  {
    id: "audio",
    numeric: false,
    disablePadding: true,
    label: "Audio",
    width: 90,
  },
  {
    id: "id",
    numeric: false,
    disablePadding: true,
    label: "QT ID",
  },
  {
    id: "userData.userName",
    numeric: false,
    disablePadding: true,
    label: "Created By",
  },
  {
    id: "createdAt",
    numeric: false,
    disablePadding: true,
    label: "Creation Date",
  },
  {
    id: "audioLength",
    numeric: false,
    disablePadding: true,
    label: "Length",
    width: 100,
  },
  {
    id: "position",
    numeric: false,
    disablePadding: true,
    label: "Position",
    width: 90,
  },
];

export const AddQuicktalesToAreaTableHeadCells = [
  {
    id: "qtTitle",
    numeric: false,
    disablePadding: true,
    label: "QT Title",
  },
  {
    id: "photo",
    numeric: false,
    disablePadding: true,
    label: "Photo",
    width: 90,
  },
  {
    id: "audio",
    numeric: false,
    disablePadding: true,
    label: "Audio",
    width: 90,
  },
  {
    id: "qtId",
    numeric: false,
    disablePadding: true,
    label: "QT ID",
  },
  {
    id: "createdBy",
    numeric: false,
    disablePadding: true,
    label: "Created By",
  },
  {
    id: "toldBy",
    numeric: false,
    disablePadding: true,
    label: "Told By",
    width: 170,
  },
  {
    id: "listenerType",
    numeric: false,
    disablePadding: true,
    label: "Who Can Listen",
    width: 150,
  },
  {
    id: "qtStatus",
    numeric: false,
    disablePadding: true,
    label: "QT Status",
    width: 100,
  },
  {
    id: "approvalStatus.updatedAt",
    numeric: false,
    disablePadding: true,
    label: "Status Change Date",
    width: 180,
  },
  {
    id: "audioLength",
    numeric: false,
    disablePadding: true,
    label: "Length",
    width: 100,
  },
  {
    id: "position",
    numeric: false,
    disablePadding: true,
    label: "Position",
    width: 90,
  },
];

export const AddQuicktalesToOrgTableHeadCells = [
  {
    id: "csvRow",
    numeric: true,
    disablePadding: true,
    label: "Row 1",
    width: 90,
  },
  {
    id: "title",
    numeric: false,
    disablePadding: true,
    label: "QT Title",
    width: 300,
  },
  {
    id: "approvalStatus.status",
    numeric: false,
    disablePadding: true,
    label: "QT Org Status",
    width: 170,
  },
  {
    id: "isDraft",
    numeric: false,
    disablePadding: true,
    label: "QT Status",
    width: 110,
  },
  {
    id: "photo",
    numeric: false,
    disablePadding: true,
    label: "Photo",
    width: 90,
  },
  {
    id: "audio",
    numeric: false,
    disablePadding: true,
    label: "Audio",
    width: 90,
  },
  {
    id: "areaIdResolved",
    numeric: false,
    disablePadding: true,
    label: "Area",
    width: 170,
  },
  {
    id: "narratorData.userName",
    numeric: false,
    disablePadding: true,
    label: "Told By",
    width: 170,
  },
  {
    id: "status",
    numeric: false,
    disablePadding: true,
    label: "Who Can Listen",
    width: 150,
  },
  {
    id: "lastEmailSentAt",
    numeric: false,
    disablePadding: true,
    label: "Last Email Sent",
    width: 200,
  },
  {
    id: "lastEmailStatus",
    numeric: false,
    disablePadding: true,
    label: "Email Status",
    width: 140,
  },
  {
    id: "updatedAt",
    numeric: false,
    disablePadding: true,
    label: "Last Updated",
    width: 200,
  },
  {
    id: "createdByData.userName",
    numeric: false,
    disablePadding: true,
    label: "Created By",
    width: 170,
  },
  {
    id: "approvalStatus.updatedAt",
    numeric: false,
    disablePadding: true,
    label: "Status Change Date",
    width: 200,
  },
  {
    id: "autoApprove",
    numeric: false,
    disablePadding: true,
    label: "Auto Approve",
    width: 120,
  }
];

export const AdminsTableHeadCells = [
  {
    id: "firstName",
    numeric: false,
    disablePadding: true,
    label: "First Name",
    width: 170,
  },
  {
    id: "lastName",
    numeric: false,
    disablePadding: true,
    label: "Last name",
    width: 140,
  },
  {
    id: "userName",
    numeric: false,
    disablePadding: true,
    label: "Username",
    width: 140,
  },
  {
    id: "createdAt",
    numeric: false,
    disablePadding: true,
    label: "Date Added",
    width: 140,
  },
  {
    id: "status",
    numeric: false,
    disablePadding: true,
    label: "Status",
    width: 140,
  },
  {
    id: "role",
    numeric: false,
    disablePadding: true,
    label: "Role",
    width: 140,
  },
  {
    id: "lastLoginDate",
    numeric: false,
    disablePadding: true,
    label: "Last Login",
    width: 170,
  },
];

export const GAAdminsTableHeadCells = [
  {
    id: "firstName",
    numeric: false,
    disablePadding: true,
    label: "First Name",
    width: 170,
  },
  {
    id: "lastName",
    numeric: false,
    disablePadding: true,
    label: "Last name",
    width: 140,
  },
  {
    id: "userName",
    numeric: false,
    disablePadding: true,
    label: "Username",
    width: 140,
  },
  {
    id: "createdAt",
    numeric: false,
    disablePadding: true,
    label: "Date Added",
    width: 140,
  },
    {
    id: "email",
    numeric: false,
    disablePadding: true,
    label: "Email",
    width: 140,
  },
    {
    id: "id",
    numeric: false,
    disablePadding: true,
    label: "ID",
    width: 140,
  },
    {
    id: "organization",
    numeric: false,
    disablePadding: true,
    label: "Organization",
    width: 140,
  },
  {
    id: "status",
    numeric: false,
    disablePadding: true,
    label: "Status",
    width: 140,
  },
  {
    id: "role",
    numeric: false,
    disablePadding: true,
    label: "Role",
    width: 140,
  },
  {
    id: "lastLoginDate",
    numeric: false,
    disablePadding: true,
    label: "Last Login",
    width: 170,
  },
];

function createAdminData(
  id,
  firstName,
  lastName,
  username,
  dateAdded,
  status,
  role,
  lastLogin
) {
  return {
    id,
    firstName,
    lastName,
    username,
    dateAdded,
    status,
    role,
    lastLogin,
  };
}

export const AdminsData = [
  createAdminData(
    1,
    "John",
    "Samson",
    "jsamson",
    "12/15/2022",
    "Active",
    "Curator",
    "12/15/2022"
  ),
  createAdminData(
    2,
    "Lily",
    "Johnson",
    "l_johson",
    "12/15/2022",
    "Active",
    "Admin",
    "12/15/2022"
  ),
  createAdminData(
    3,
    "Ethan",
    "Davis",
    "e_davis",
    "12/15/2022",
    "Active",
    "Invited",
    "12/15/2022"
  ),
  createAdminData(
    4,
    "Olivia",
    "Martiniz",
    "O_marti",
    "12/15/2022",
    "Active",
    "Admin",
    "12/15/2022"
  ),
  createAdminData(
    5,
    "Benjamin",
    "Smith",
    "Be_smith",
    "12/15/2022",
    "Not Active",
    "Curator",
    "12/15/2022"
  ),
  createAdminData(
    6,
    "Chloe",
    "Wilson",
    "C_wilson",
    "12/15/2022",
    "Active",
    "Admin",
    "12/15/2022"
  ),
  createAdminData(
    7,
    "John",
    "Samson",
    "jsamson",
    "12/15/2022",
    "Active",
    "Curator",
    "12/15/2022"
  ),
  createAdminData(
    8,
    "Lily",
    "Johnson",
    "l_johson",
    "12/15/2022",
    "Active",
    "Admin",
    "12/15/2022"
  ),
  createAdminData(
    9,
    "Ethan",
    "Davis",
    "e_davis",
    "12/15/2022",
    "Active",
    "Invited",
    "12/15/2022"
  ),
  createAdminData(
    10,
    "Olivia",
    "Martiniz",
    "O_marti",
    "12/15/2022",
    "Active",
    "Admin",
    "12/15/2022"
  ),
  createAdminData(
    11,
    "Benjamin",
    "Smith",
    "Be_smith",
    "12/15/2022",
    "Not Active",
    "Curator",
    "12/15/2022"
  ),
  createAdminData(
    12,
    "Chloe",
    "Wilson",
    "C_wilson",
    "12/15/2022",
    "Active",
    "Admin",
    "12/15/2022"
  ),
  createAdminData(
    13,
    "John",
    "Samson",
    "jsamson",
    "12/15/2022",
    "Active",
    "Curator",
    "12/15/2022"
  ),
  createAdminData(
    14,
    "Lily",
    "Johnson",
    "l_johson",
    "12/15/2022",
    "Active",
    "Admin",
    "12/15/2022"
  ),
  createAdminData(
    15,
    "Ethan",
    "Davis",
    "e_davis",
    "12/15/2022",
    "Active",
    "Invited",
    "12/15/2022"
  ),
  createAdminData(
    16,
    "Olivia",
    "Martiniz",
    "O_marti",
    "12/15/2022",
    "Active",
    "Admin",
    "12/15/2022"
  ),
  createAdminData(
    17,
    "Benjamin",
    "Smith",
    "Be_smith",
    "12/15/2022",
    "Not Active",
    "Curator",
    "12/15/2022"
  ),
  createAdminData(
    18,
    "Chloe",
    "Wilson",
    "C_wilson",
    "12/15/2022",
    "Active",
    "Admin",
    "12/15/2022"
  ),
];

export const AddAdminTableHeadCells = [
  {
    id: "firstName",
    numeric: false,
    disablePadding: true,
    label: "First Name",
  },
  {
    id: "lastName",
    numeric: false,
    disablePadding: true,
    label: "Last name",
  },
  {
    id: "username",
    numeric: false,
    disablePadding: true,
    label: "Username",
  },
  {
    id: "role",
    numeric: false,
    disablePadding: true,
    label: "Role",
  },
];

export const AreaManagementTableHeadCells = [
    {
    id: "position",
    numeric: false,
    disablePadding: true,
    label: "Position",
    width: 100,
  },
  {
    id: "name",
    numeric: false,
    disablePadding: true,
    label: "Area Name",
    width: 380,
  },
  {
    id: "isActive",
    numeric: false,
    disablePadding: true,
    label: "Area Status",
    width: 150,
  },
  {
    // Sorts by the resolved count array (comparator compares array lengths).
    id: "numberOfQTs",
    numeric: false,
    disablePadding: true,
    label: "# of QT in Area",
    width: 150,
  },
  {
    id: "updatedAt",
    numeric: false,
    disablePadding: true,
    label: "Last Modified Date",
    width: 180,
  },
  {
    id: "quickCollect",
    numeric: false,
    disablePadding: true,
    label: "QuickCollect Link",
    width: 240,
    sortable: false,
  },
];

// Appended to AreaManagementTableHeadCells for superadmins only.
export const AreaManagementDeletedHeadCell = {
  id: "isDeleted",
  numeric: false,
  disablePadding: true,
  label: "",
  width: 20,
  cellPadding: 0,
  sortable: false,
};

function createAreaManagementData(
  id,
  areaName,
  status,
  noOfQTInArea,
  position
) {
  return {
    id,
    areaName,
    status,
    noOfQTInArea,
    position,
  };
}

export const AreaManagementData = [
  createAreaManagementData(1, "All", "Active", 17, 1),
  createAreaManagementData(2, "Nearby", "Active", 8, 2),
  createAreaManagementData(3, "Park", "Active", 6, 3),
  createAreaManagementData(4, "Reactions", "Active", 5, 4),
  createAreaManagementData(5, "Art Shows", "Inactive", 4, "N/A"),
];

export const GAReactionsTableHeadCells = [
  {
    id: "quicktaleData.title",
    numeric: false,
    disablePadding: true,
    label: "QuickTales Title",
    width: 200,
  },
  {
    id: "audio",
    numeric: false,
    disablePadding: true,
    label: "Reaction Audio",
    width: 150,
  },
  {
    id: "id",
    numeric: false,
    disablePadding: true,
    label: "Reaction Id",
    width: 140,
  },
  {
    id: "status",
    numeric: false,
    disablePadding: true,
    label: "Reaction Status",
    width: 170,
  },
  {
    id: "userData.userName",
    numeric: false,
    disablePadding: true,
    label: "Reaction By",
    width: 170,
  },
  {
    id: "createdAt",
    numeric: false,
    disablePadding: true,
    label: "Created Date",
    width: 170,
  },

  {
    id: "audioLength",
    numeric: false,
    disablePadding: true,
    label: "Length",
    width: 100,
  },
  {
    id: "photo",
    numeric: false,
    disablePadding: true,
    label: "QT Photo",
    width: 120,
  },
  {
    id: "quicktale",
    numeric: false,
    disablePadding: true,
    label: "QT Id",
    width: 170,
  },
  {
    id: "reportedStatus",
    numeric: false,
    disablePadding: true,
    label: "Reported Status",
    width: 155,
  },
];
export const GAAlbumsTableHeadCells = [
  {
    id: "albumTitle",
    numeric: false,
    disablePadding: true,
    label: "Album Title",
  },
  {
    id: "albumPhoto",
    numeric: false,
    disablePadding: true,
    label: "Album Photo",
    width: 120,
  },
  {
    id: "albumId",
    numeric: false,
    disablePadding: true,
    label: "Album Id",
  },
  {
    id: "createdBy",
    numeric: false,
    disablePadding: true,
    label: "Created By",
  },
  {
    id: "albumDescription",
    numeric: false,
    disablePadding: true,
    label: "Album Description",
  },
  {
    id: "albumStatus",
    numeric: false,
    disablePadding: true,
    label: "Album Status",
  },

  {
    id: "creationDate",
    numeric: false,
    disablePadding: true,
    label: "Creation Date",
  },
  {
    id: "noOfQT",
    numeric: false,
    disablePadding: true,
    label: "# of QT in Album",
  },
  {
    id: "length",
    numeric: false,
    disablePadding: true,
    label: "Length",
    width: 100,
  },
];
export const GAUsersTableHeadCells = [
  {
    id: "firstName",
    numeric: false,
    disablePadding: true,
    label: "First Name",
    width: 170,
  },
  {
    id: "lastName",
    numeric: false,
    disablePadding: true,
    label: "Last name",
    width: 170,
  },
  {
    id: "userName",
    numeric: false,
    disablePadding: true,
    label: "Username",
    width: 170,
  },
  {
    id: "id",
    numeric: false,
    disablePadding: true,
    label: "User ID",
    width: 190,
  },
  {
    id: "type",
    numeric: false,
    disablePadding: true,
    label: "User Type",
    width: 120,
  },
  {
    id: "createdAt",
    numeric: false,
    disablePadding: true,
    label: "Date Signup",
    width: 170,
  },
  {
    // id: "status",
    id: "isActive",
    numeric: false,
    disablePadding: true,
    label: "Account Status",
    width: 170,
  },
  {
    id: "reportedStatus",
    numeric: false,
    disablePadding: true,
    label: "Reported Status",
    width: 155,
  },
];

function createGAReactionsData(
  id,
  reactionsTitle,
  audio,
  reactionId,
  reactionStatus,
  createdBy,
  createdDate,
  length,
  photo,
  qtId,
  reportedStatus
) {
  return {
    id,
    reactionsTitle,
    audio,
    reactionId,
    reactionStatus,
    createdBy,
    createdDate,
    length,
    photo,
    qtId,
    reportedStatus,
  };
}

export const GAReactionsData = [
  createGAReactionsData(
    1,
    "Grandma's Hat: A Timeless Treasure of Love for All to Enjoy",
    "audio",
    "12345",
    "Pending",
    "john",
    "12/15/2022",
    "2:23",
    "photo",
    "1231",
    "Flagged"
  ),
  createGAReactionsData(
    1,
    "Canine Confectioner: When My Dog Got a Taste for Cake",
    "audio",
    "12345",
    "Approved",
    "Samson",
    "01/15/2022",
    "3:23",
    "photo",
    "1111",
    "Approved"
  ),
];

function createGAAlbumsData(
  id,
  albumTitle,
  photo,
  albumId,
  createdBy,
  albumDescription,
  albumStatus,
  creationDate,
  noOfQT,
  length
) {
  return {
    id,
    albumTitle,
    photo,
    albumId,
    createdBy,
    albumDescription,
    albumStatus,
    creationDate,
    noOfQT,
    length,
  };
}

export const GAAlbumsData = [
  createGAAlbumsData(
    1,
    "Grandma's Hat: A Timeless Treasure of Love for All to Enjoy",
    "photo",
    "12345",
    "Sarah",
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    "Public",
    "11/13/2022",
    "12",
    "52:34"
  ),
  createGAAlbumsData(
    1,
    "Canine Confectioner: When My Dog Got a Taste for Cake",
    "photo",
    "12312",
    "Sarah",
    "Canine Confectioner: When My Dog Got a Taste for Cake",
    "Public",
    "14/11/2021",
    "13",
    "50:14"
  ),
];

function createGAUsersData(
  id,
  firstName,
  lastName,
  username,
  dateSignup,
  accountStatus,
  reportedStatus,
  aboutMe,
  photo,
  groups,
  likes,
  following,
  followers
) {
  return {
    id,
    firstName,
    lastName,
    username,
    dateSignup,
    accountStatus,
    reportedStatus,
    aboutMe,
    photo,
    groups,
    likes,
    following,
    followers,
  };
}
export const GAUsersData = [
  createGAUsersData(
    1,
    "John",
    "Samson",
    "jsamson",
    "12/15/2022",
    "Active",
    "Reported",
    "Lorem ipsum dolor sit amet consectetur. Enim eget cursus odio varius viverra vel lacus.",
    "photo",
    12,
    200,
    50,
    46
  ),
  createGAUsersData(
    2,
    "Lily",
    "Johnson",
    "l_johson",
    "12/15/2022",
    "Active",
    "Reported",
    "Lorem ipsum dolor sit amet consectetur. Enim eget cursus odio varius viverra vel lacus.",
    "photo",
    12,
    200,
    50,
    46
  ),
  createGAUsersData(
    3,
    "Ethan",
    "Davis",
    "e_davis",
    "12/15/2022",
    "Active",
    "Reported",
    "Lorem ipsum dolor sit amet consectetur. Enim eget cursus odio varius viverra vel lacus.",
    "photo",
    12,
    200,
    50,
    46
  ),
  createGAUsersData(
    4,
    "Olivia",
    "Martiniz",
    "O_marti",
    "12/15/2022",
    "Active",
    "Reported",
    "Lorem ipsum dolor sit amet consectetur. Enim eget cursus odio varius viverra vel lacus.",
    "photo",
    12,
    200,
    50,
    46
  ),
  createGAUsersData(
    5,
    "Benjamin",
    "Smith",
    "Be_smith",
    "12/15/2022",
    "Not Active",
    "Reported",
    "Lorem ipsum dolor sit amet consectetur. Enim eget cursus odio varius viverra vel lacus.",
    "photo",
    12,
    200,
    50,
    46
  ),
  createGAUsersData(
    6,
    "Chloe",
    "Wilson",
    "C_wilson",
    "12/15/2022",
    "Active",
    "Reported",
    "Lorem ipsum dolor sit amet consectetur. Enim eget cursus odio varius viverra vel lacus.",
    "photo",
    12,
    200,
    50,
    46
  ),
  createGAUsersData(
    7,
    "John",
    "Samson",
    "jsamson",
    "12/15/2022",
    "Active",
    "Reported",
    "Lorem ipsum dolor sit amet consectetur. Enim eget cursus odio varius viverra vel lacus.",
    "photo",
    12,
    200,
    50,
    46
  ),
  createGAUsersData(
    8,
    "Lily",
    "Johnson",
    "l_johson",
    "12/15/2022",
    "Active",
    "Reported",
    "Lorem ipsum dolor sit amet consectetur. Enim eget cursus odio varius viverra vel lacus.",
    "photo",
    12,
    200,
    50,
    46
  ),
  createGAUsersData(
    9,
    "Ethan",
    "Davis",
    "e_davis",
    "12/15/2022",
    "Active",
    "Reported",
    "Lorem ipsum dolor sit amet consectetur. Enim eget cursus odio varius viverra vel lacus.",
    "photo",
    12,
    200,
    50,
    46
  ),
  createGAUsersData(
    10,
    "Olivia",
    "Martiniz",
    "O_marti",
    "12/15/2022",
    "Active",
    "Reported",
    "Lorem ipsum dolor sit amet consectetur. Enim eget cursus odio varius viverra vel lacus.",
    "photo",
    12,
    200,
    50,
    46
  ),
  createGAUsersData(
    11,
    "Benjamin",
    "Smith",
    "Be_smith",
    "12/15/2022",
    "Not Active",
    "Reported",
    "Lorem ipsum dolor sit amet consectetur. Enim eget cursus odio varius viverra vel lacus.",
    "photo",
    12,
    200,
    50,
    46
  ),
  createGAUsersData(
    12,
    "Chloe",
    "Wilson",
    "C_wilson",
    "12/15/2022",
    "Active",
    "Reported",
    "Lorem ipsum dolor sit amet consectetur. Enim eget cursus odio varius viverra vel lacus.",
    "photo",
    12,
    200,
    50,
    46
  ),
  createGAUsersData(
    13,
    "John",
    "Samson",
    "jsamson",
    "12/15/2022",
    "Active",
    "Reported",
    "Lorem ipsum dolor sit amet consectetur. Enim eget cursus odio varius viverra vel lacus.",
    "photo",
    12,
    200,
    50,
    46
  ),
  createGAUsersData(
    14,
    "Lily",
    "Johnson",
    "l_johson",
    "12/15/2022",
    "Active",
    "Reported",
    "Lorem ipsum dolor sit amet consectetur. Enim eget cursus odio varius viverra vel lacus.",
    "photo",
    12,
    200,
    50,
    46
  ),
  createGAUsersData(
    15,
    "Ethan",
    "Davis",
    "e_davis",
    "12/15/2022",
    "Active",
    "Reported",
    "Lorem ipsum dolor sit amet consectetur. Enim eget cursus odio varius viverra vel lacus.",
    "photo",
    12,
    200,
    50,
    46
  ),
  createGAUsersData(
    16,
    "Olivia",
    "Martiniz",
    "O_marti",
    "12/15/2022",
    "Active",
    "Reported",
    "Lorem ipsum dolor sit amet consectetur. Enim eget cursus odio varius viverra vel lacus.",
    "photo",
    12,
    200,
    50,
    46
  ),
  createGAUsersData(
    17,
    "Benjamin",
    "Smith",
    "Be_smith",
    "12/15/2022",
    "Not Active",
    "Reported",
    "Lorem ipsum dolor sit amet consectetur. Enim eget cursus odio varius viverra vel lacus.",
    "photo",
    12,
    200,
    50,
    46
  ),
  createGAUsersData(
    18,
    "Chloe",
    "Wilson",
    "C_wilson",
    "12/15/2022",
    "Active",
    "Reported",
    "Lorem ipsum dolor sit amet consectetur. Enim eget cursus odio varius viverra vel lacus.",
    "photo",
    12,
    200,
    50,
    46
  ),
];

export const GAQuicktalesTableHeadCells = [
  {
    id: "title",
    numeric: false,
    disablePadding: true,
    label: "QT Title",
    width: 250,
  },
  {
    id: "photo",
    numeric: false,
    disablePadding: true,
    label: "Photo",
    width: 90,
  },
  {
    id: "audio",
    numeric: false,
    disablePadding: true,
    label: "Audio",
    width: 90,
  },
  {
    id: "createdAt",
    numeric: false,
    disablePadding: true,
    label: "Creation Date",
    width: 170,
  },
  {
    id: "createdByData.userName",
    numeric: false,
    disablePadding: true,
    label: "Created By",
    width: 130,
  },
  {
    id: "narratorData.userName",
    numeric: false,
    disablePadding: true,
    label: "Told By",
    width: 130,
  },
  {
    id: "status",
    numeric: false,
    disablePadding: true,
    label: "Who Can Listen",
    width: 150,
  },
  {
    id: "isDraft",
    // id: "approvalStatus.status",
    numeric: false,
    disablePadding: true,
    label: "QT Status",
    width: 120,
  },
  // Reported Status column temporarily removed for performance (per-QT report
  // fetch was 1 Firestore query per QuickTale). Restore with the fetch logic in
  // QuickTalesProvider.handleGetGAQuickTales if needed.
  // {
  //   id: "reportedStatus",
  //   numeric: false,
  //   disablePadding: true,
  //   label: "Reported Status",
  //   width: 155,
  // },
  {
    id: "id",
    numeric: false,
    disablePadding: true,
    label: "QT ID",
    width: 200,
  },
  {
    id: "visionIndexedAt",

    numeric: false,
    disablePadding: true,
    label: "Index Date",
    width: 170,
  },
];

export const GAOrganizationsDetailTableHeadCells = [

  {
    id: "dateReported",
    numeric: false,
    disablePadding: true,
    label: "Status Change Date",
  },
  {
    id: "reportStatus",
    numeric: false,
    disablePadding: true,
    label: "Reported Status",
  },
  {
    id: "action",
    numeric: false,
    disablePadding: true,
    label: "Action",
  },
  {
    id: "note",
    numeric: false,
    disablePadding: true,
    label: "Note",
  },
];

function createGAOrganizationsDetailData(
  id,
  reportDate,
  reportStatus,
  action,
  note
) {
  return {
    id,
    reportDate,
    reportStatus,
    action,
    note,
  };
}

export const GAOrganizationsDetailData = [
  createGAOrganizationsDetailData(
    1,
    "12/03/2023",
    "Reported",
    "None",
    "Message user here"
  ),
  createGAOrganizationsDetailData(
    2,
    "12/03/2023",
    "Reported",
    "None",
    "Message user here"
  ),
  createGAOrganizationsDetailData(
    3,
    "12/03/2023",
    "Reported",
    "None",
    "Message user here"
  ),
];

export const GAOrganizationsTableHeadCells = [
  {
    id: "name",
    numeric: false,
    disablePadding: true,
    label: "Organization Title",
    width: 200,
  },
  {
    id: "photo",
    numeric: false,
    disablePadding: true,
    label: "Org Photo",
    width: 170,
  },
  {
    id: "id",
    numeric: false,
    disablePadding: true,
    label: "Org ID",
    width: 170,
  },
  {
    id: "handle",
    numeric: false,
    disablePadding: true,
    label: "Org Username",
    width: 200,
  },
  {
    id: "orgContact",
    numeric: false,
    disablePadding: true,
    label: "Org Contact",
    width: 200,
  },
  {
    id: "createdAt",
    numeric: false,
    disablePadding: true,
    label: "Creation Date",
    width: 200,
  },
  {
    id: "userData.email",
    // id: "orgEmail",
    numeric: false,
    disablePadding: true,
    label: "Org E-mail",
    width: 200,
  },
  // {
  //   id: "dateCreated",
  //   numeric: false,
  //   disablePadding: true,
  //   label: "Date Created",
  // },
  {
    id: "status",
    numeric: false,
    disablePadding: true,
    label: "Status",
    width: 120,
  },
  {
    id: "pinOrder",
    numeric: true,
    disablePadding: true,
    label: "Pin Order",
    width: 100,
  },
];
function createGAOrganizationsData(
  id,
  title,
  photo,
  orgId,
  orgUsername,
  orgContact,
  phone,
  creationDate,
  orgEmail,
  dateCreated,
  status
) {
  return {
    id,
    title,
    photo,
    orgId,
    orgUsername,
    orgContact,
    phone,
    creationDate,
    orgEmail,
    dateCreated,
    status,
  };
}

export const GAOrganizationsData = [
  createGAOrganizationsData(
    1,
    "Los Angeles State Historic Park",
    "image",
    "12345",
    "@LASHP",
    "Sarah",
    "123456789",
    "12-13-2023",
    "lashp@gmail.com",
    "12-13-2023",
    "Active"
  ),
  createGAOrganizationsData(
    2,
    "The Huntingon",
    "image",
    "12345",
    "@LASHP",
    "Sarah",
    "123456789",
    "12-13-2023",
    "lashp@gmail.com",
    "12-13-2023",
    "Active"
  ),
  createGAOrganizationsData(
    3,
    "The Museum of Contemporary Art",
    "image",
    "12345",
    "@LASHP",
    "Sarah",
    "123456789",
    "12-13-2023",
    "lashp@gmail.com",
    "12-13-2023",
    "Active"
  ),
  createGAOrganizationsData(
    4,
    "Petersen Automotive Museum",
    "image",
    "12345",
    "@LASHP",
    "Sarah",
    "123456789",
    "12-13-2023",
    "lashp@gmail.com",
    "12-13-2023",
    "Active"
  ),
  createGAOrganizationsData(
    5,
    "The Museum of Contemporary Art",
    "image",
    "12345",
    "@LASHP",
    "Sarah",
    "123456789",
    "12-13-2023",
    "lashp@gmail.com",
    "12-13-2023",
    "Active"
  ),
  createGAOrganizationsData(
    6,
    "Los Angeles State Historic Park",
    "image",
    "12345",
    "@LASHP",
    "Sarah",
    "123456789",
    "12-13-2023",
    "lashp@gmail.com",
    "12-13-2023",
    "Active"
  ),
  createGAOrganizationsData(
    7,
    "Petersen Automotive Museum",
    "image",
    "12345",
    "@LASHP",
    "Sarah",
    "123456789",
    "12-13-2023",
    "lashp@gmail.com",
    "12-13-2023",
    "Active"
  ),
  createGAOrganizationsData(
    8,
    "Los Angeles State Historic Park",
    "image",
    "12345",
    "@LASHP",
    "Sarah",
    "123456789",
    "12-13-2023",
    "lashp@gmail.com",
    "12-13-2023",
    "Active"
  ),
  createGAOrganizationsData(
    9,
    "The Museum of Contemporary Art",
    "image",
    "12345",
    "@LASHP",
    "Sarah",
    "123456789",
    "12-13-2023",
    "lashp@gmail.com",
    "12-13-2023",
    "Active"
  ),
  createGAOrganizationsData(
    10,
    "Petersen Automotive Museum",
    "image",
    "12345",
    "@LASHP",
    "Sarah",
    "123456789",
    "12-13-2023",
    "lashp@gmail.com",
    "12-13-2023",
    "Active"
  ),
  createGAOrganizationsData(
    11,
    "Los Angeles State Historic Park",
    "image",
    "12345",
    "@LASHP",
    "Sarah",
    "123456789",
    "12-13-2023",
    "lashp@gmail.com",
    "12-13-2023",
    "Active"
  ),
  createGAOrganizationsData(
    12,
    "The Museum of Contemporary Art",
    "image",
    "12345",
    "@LASHP",
    "Sarah",
    "123456789",
    "12-13-2023",
    "lashp@gmail.com",
    "12-13-2023",
    "Active"
  ),
  createGAOrganizationsData(
    13,
    "Los Angeles State Historic Park",
    "image",
    "12345",
    "@LASHP",
    "Sarah",
    "123456789",
    "12-13-2023",
    "lashp@gmail.com",
    "12-13-2023",
    "Active"
  ),
  createGAOrganizationsData(
    14,
    "Petersen Automotive Museum",
    "image",
    "12345",
    "@LASHP",
    "Sarah",
    "123456789",
    "12-13-2023",
    "lashp@gmail.com",
    "12-13-2023",
    "Active"
  ),
  createGAOrganizationsData(
    15,
    "The Museum of Contemporary Art",
    "image",
    "12345",
    "@LASHP",
    "Sarah",
    "123456789",
    "12-13-2023",
    "lashp@gmail.com",
    "12-13-2023",
    "Active"
  ),
  createGAOrganizationsData(
    16,
    "Petersen Automotive Museum",
    "image",
    "12345",
    "@LASHP",
    "Sarah",
    "123456789",
    "12-13-2023",
    "lashp@gmail.com",
    "12-13-2023",
    "Active"
  ),
  createGAOrganizationsData(
    17,
    "The Museum of Contemporary Art",
    "image",
    "12345",
    "@LASHP",
    "Sarah",
    "123456789",
    "12-13-2023",
    "lashp@gmail.com",
    "12-13-2023",
    "Active"
  ),
  createGAOrganizationsData(
    18,
    "Los Angeles State Historic Park",
    "image",
    "12345",
    "@LASHP",
    "Sarah",
    "123456789",
    "12-13-2023",
    "lashp@gmail.com",
    "12-13-2023",
    "Active"
  ),
];

export const GAReportedTableHeadCells = [
  {
    id: "id",
    numeric: false,
    disablePadding: true,
    label: "Reported ID#",
    // label: "Report ID#",
    width: 200,
  },
  {
    id: "createdAt",
    numeric: false,
    disablePadding: true,
    label: "Date Reported",
    width: 170,
  },
  {
    id: "status.status",
    numeric: false,
    disablePadding: true,
    label: "Reported Status",
    width: 155,
  },
  {
    id: "status.action",
    numeric: false,
    disablePadding: true,
    label: "Action Taken",
    width: 150,
  },
  {
    id: "reportedByData.userName",
    numeric: false,
    disablePadding: true,
    label: "Reporter Username",
    width: 200,
  },
  {
    id: "type",
    numeric: false,
    disablePadding: true,
    label: "Reported Type",
    width: 170,
  },
  {
    id: "reason",
    numeric: false,
    disablePadding: true,
    label: "Reported Reason",
    width: 170,
  },
  {
    id: "title",
    numeric: false,
    disablePadding: true,
    // label: "QuickTale Title",
    label: "Reported Title",
    width: 170,
  },
  {
    id: "reportedItemId",
    numeric: false,
    disablePadding: true,
    label: "Reported Item ID",
    width: 200,
  },
  // {
  //   id: "reportedItemId",
  //   numeric: false,
  //   disablePadding: true,
  //   label: "QuickTale ID#",
  //   width: 200,
  // },
  // {
  //   id: "reactionId",
  //   numeric: false,
  //   disablePadding: true,
  //   label: "Reaction ID#",
  //   width: 200,
  // },
];

function createGAReportedData(
  id,
  dateReported,
  reportedId,
  reportedStatus,
  reporterUsername,
  reporterType,
  reportedReason,
  qtTitle,
  qtId,
  reactionId,
  actionTaken
) {
  return {
    id,
    dateReported,
    reportedId,
    reportedStatus,
    reporterUsername,
    reporterType,
    reportedReason,
    qtTitle,
    qtId,
    reactionId,
    actionTaken,
  };
}

export const GAReportsData = [
  createGAReportedData(
    1,
    "12-13-2023",
    "001",
    "Reported",
    "@LASHP",
    "User",
    "",
    "Los Angeles State Historic Park",
    "12345",
    "12345",
    ""
  ),
  createGAReportedData(
    2,
    "01-13-2024",
    "002",
    "Pending",
    "@sophia",
    "QuickTales",
    "",
    "The Huntingon",
    "87655",
    "87655",
    ""
  ),
  createGAReportedData(
    3,
    "01-18-2024",
    "003",
    "Resolved",
    "@stark",
    "Reaction",
    "",
    "Petersen Automotive Museum",
    "34567",
    "34567",
    ""
  ),
];

export const StatusHistoryTableHeadCells = [
  {
    id: "date",
    numeric: false,
    disablePadding: true,
    label: "Status Change Date",
    width: 100,
    maxwidth: 150,
  },
  {
    id: "status",
    numeric: false,
    disablePadding: true,
    label: "Reported Status",
    width: 100,
    maxwidth: 150,
  },
  {
    id: "action",
    numeric: false,
    disablePadding: true,
    label: "Action",
    width: 100,
    maxwidth: 150,
  },
  {
    id: "notes",
    numeric: false,
    disablePadding: true,
    label: "Notes",
    width: 300,
    maxwidth: 500,
  },
  {
    id: "updatedBy",
    numeric: false,
    disablePadding: true,
    label: "Admin User",
    width: 130,
    maxwidth: 150,
  },
];

export const NotificationsTableHeadCells = [
  {
    id: "message",
    numeric: false,
    disablePadding: true,
    label: "Message",
    width: 600,
  },
  {
    id: "createdAt",
    numeric: false,
    disablePadding: true,
    label: "Date",
    width: 170,
  },
];

export const EmailTemplatesTableHeadCells = [
  {
    id: "name",
    numeric: false,
    disablePadding: true,
    label: "Name",
    width: 250,
  },
  {
    id: "description",
    numeric: false,
    disablePadding: true,
    label: "Description",
    width: 300,
  },
  {
    id: "logo",
    numeric: false,
    disablePadding: true,
    label: "Logo",
    width: 80,
  },
  {
    id: "updatedAt",
    numeric: false,
    disablePadding: true,
    label: "Updated At",
    width: 170,
  },
  {
    id: "updatedByData.userName",
    numeric: false,
    disablePadding: true,
    label: "Updated By",
    width: 150,
  },
  {
    id: "status",
    numeric: false,
    disablePadding: true,
    label: "Status",
    width: 120,
  },
  {
    id: "default",
    numeric: false,
    disablePadding: true,
    label: "Default",
    width: 120,
  },
];
// QuickConnect (QuickCollect) guest-page templates.
// Only Name + Greeting exist on the doc, so the table stays deliberately narrow.
// See docs/QUICKCOLLECT_IMPLEMENTATION.md
export const QCTemplatesTableHeadCells = [
  {
    id: "name",
    numeric: false,
    disablePadding: true,
    label: "Name",
    width: 250,
  },
  {
    id: "greeting",
    numeric: false,
    disablePadding: true,
    label: "Greeting",
    width: 400,
  },
  {
    id: "updatedAt",
    numeric: false,
    disablePadding: true,
    label: "Updated At",
    width: 170,
  },
  {
    id: "updatedByData.userName",
    numeric: false,
    disablePadding: true,
    label: "Updated By",
    width: 150,
  },
];
